import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useLocation, useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchMobileApp,
  fetchFakeSocialMedia,
  fetchMobileRemidiatedFalseTrue,
  fetchSocailRemidiatedFalseTrue,
  getSuspicousCloudData,
  fetchMobileAppUpdate,
  fetchMobileAppDelete,
  fetchFakeSocialMediaUpdate,
  fetchFakeSocialMediaDelete,
  cloudBucketDeleteById,
  cloudUpdateById,
} from "../../actions/fakeMobileApp";
import { fetchPastebinResult, pastebinDelete, pastebinUpdate } from "../../actions/pastebin";
import Dropzone from "../common/DropzoneExample";
import {
  fetchLeakedCode,
  fetchLeakedCodeAction,
  fetchLeakedCodeDelete,
  fetchLeakedCodeUpdate
} from "../../actions/leakedCode";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import { Tabs, Tab, Row, Col, Nav } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import NoData from "../common/noDataComponetnt";
import { fetchDarkWebResult, fetchDarkWebDelete, fetchDarkWebResultUpdate } from "../../actions/darkweb";
import Fancybox from "../../utils/Fancybox";
import $, { data } from "jquery";
import { fetchMalwareCredentials, fetchPiiDetails, telegram, fetchLeakedCredentials, telegramDelete, telegramUpdate, leakedCredentialsUpdate, leakedCredentialsDelete, piiDelete, piiUpdateById, malwareCredentialsDelete, malwareCredentialsUpdate, fetchLeakedSession, fetchLeakedSessionAction, addLeakedSession, updateLeakedSession, deleteLeakedSession as deleteLeakedSessionAPI, postManDelta, postManGraph } from "../../actions/leakedCredentials";
import {
  brandMention, brandMentionDelete, brandMentionUpdate, allPort,
  fetchIpDiscovery,
  allCountry,
  allCloud,
  assetsIpDelete,
  updateIpPorts
} from "../../actions/inventory";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import Tooltip from "../common/toolTip";
import { toastr } from "react-redux-toastr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import axios from "axios";
import { API_URL } from "../../utils/constant";


var Model = require("./model");




const ShowInformation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const locationUse = useLocation();

  // Malware credentials state and handlers
  const malwareCredentials = useSelector((state) => state.leakedCredential?.malware);
  const [selectedMalwareIds, setSelectedMalwareIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const handleSelectAllMalware = () => {
    if (!Array.isArray(malware?.data)) {
      return;
    }
    if (!multiCheckTrue) {
      // If not all selected, select all
      const allIds = malware.data.map(item => item._id);
      setSelectedMalwareIds(allIds);
      setMultiCheckTrue(true);
    } else {
      // If all selected, deselect all
      setSelectedMalwareIds([]);
      setMultiCheckTrue(false);
    }
  };

  const handleSelectMalware = (id) => {
    setSelectedMalwareIds(prev => {
      const newSelection = prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id];

      // Update multiCheckTrue based on if all items are selected
      setMultiCheckTrue(newSelection.length === malware?.data?.length);

      return newSelection;
    });
  };

  const [filterData, setfilterData] = useState("");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState("");
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [isModalTrue, setModalSet] = useState(false);
  const [detail, setdetail] = useState("");
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(locationUse.search);
    return params.get('tab') || 'mobile';
  });
  const vendorName = sessionStorage.getItem('vendorName');
  const [toggleArray, setToggleArray] = useState({});
  const [category, setCategory] = useState("all");
  const [totalItemsMob, setTotalItemsMob] = useState(0);
  const [pageMob, setPageMob] = useState(1);
  const [totalItemsSource, setTotalItemsSource] = useState(0);
  const [repo, setRepo] = useState([]);
  const [snoozeCon, setSnoozeCon] = useState("");
  const [startDateMobile, setStartDateMobile] = useState("");
  const [endDateMobile, setEndDateMobile] = useState("");
  const [mobSearch, setMobSearch] = useState("");
  const [mobEmail, setMobEmail] = useState("");
  const [startDateSource, setStartDateSource] = useState("");
  const [startDateSocial, setStartDateSocial] = useState("");
  const [endDateSocial, setEndDateSocial] = useState("");
  const [endDateSource, setEndDateSource] = useState("");
  const [platform, setPlatform] = useState("all");
  const [status, setStatus] = useState("all");
  const [startDatePasteBin, setStartDatePasteBin] = useState("");
  const [endDatePasteBin, setEndDatePasteBin] = useState("");
  const [search, setSearch] = useState("");
  const [startDateTelegram, setStartDateTelegram] = useState("");
  const [endDateTelegram, setEndDateTelegram] = useState("");
  const [searchMalware, setSearchMalware] = useState("");
  const [startDateMalware, setStartDateMalware] = useState("");
  const [endDateMalware, setEndDateMalware] = useState("");
  const [searchPii, setSearchPii] = useState("");
  const [startDatePii, setStartDatePii] = useState("");
  const [endDatePii, setEndDatePii] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [searchStolen, setSearchStolen] = useState("");
  const [startDateStolen, setStartDateStolen] = useState("");
  const [endDateStolen, setEndDateStolen] = useState("");
  const [applyPortSearch, setApplyPortSearch] = useState([]);
  const [filterDataCloud, setfilterDataCloud] = useState("");
  const [startDateCloud, setStartDateCloud] = useState("");
  const [searchCloud, setSearchCloud] = useState("");
  const [endDateCloud, setEndDateCloud] = useState("");
  const [darkWebPage, setDarkWebPage] = useState(1);
  const [totalItemsDarkWeb, setTotalItemsDarkWeb] = useState(1);
  const [startDateDarkWeb, setStartDateDarkWeb] = useState("");
  const [endDateDarkWeb, setEndDateDarkWeb] = useState("");
  const [telegramTotal, setTelegramTotal] = useState(1);
  const [telegramPage, setTelegramPage] = useState(1);
  const [malwareTotal, setMalwareTotal] = useState(1);
  const [malwarePage, setMalwarePage] = useState(1);
  const [piiPage, setPiiPage] = useState(1);
  const [piiTotal, setPiiTotal] = useState(1);
  const [stolenTotal, setStolenTotal] = useState(1);
  const [stolenPage, setStolenPage] = useState(1);
  const [brandMentionPage, setBrandMentionPage] = useState(1);
  const [brandMentionSearch, setBrandMentionSearch] = useState(1);
  const [brandMentionTotal, setBrandMentionTotal] = useState(1);
  const [cloudPage, setCloudPage] = useState(1);
  const [cloudTotal, setCloudTotal] = useState(1);
  const [domainFilter, setDomainFilter] = useState("all");
  const [applyCountrySearch, setApplyCountrySearch] = useState([]);
  const [applyCloudSearch, setApplyCloudSearch] = useState([]);
  const [applyCriticality, setApplyCriticality] = useState([]);
  const [totalItemsIpPorts, setTotalItemsIpPorts] = useState(0);
  const [hosts, setHosts] = useState([]);
  const [limit, setLimit] = useState(10);
  const [isModalhost, setModalHost] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [pageIpPorts, setPageIpPorts] = useState(1);
  const [cloudOrISPProvider, setCloudOrISPProvider] = useState("");
  const [highestSeverity, setHighestSeverity] = useState("");
  const [ip, setIp] = useState("");
  const [location, setLocation] = useState("");
  const [subdomains, setSubdomains] = useState("");
  const [operatingSystem, setOperatingSystem] = useState("");
  const [updatedAtIp, setUpdatedAtIp] = useState("");
  const [createdAtIp, setCreatedAtIp] = useState("");
  // const [hosts, setHosts] = useState([]);
  const [impacts, setImpacts] = useState([]);
  const [networkServices, setNetworkServices] = useState([]);
  const [openPorts, setOpenPorts] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Leaked Sessions state
  const [leakedSessionPage, setLeakedSessionPage] = useState(1);
  const [leakedSessionTotal, setLeakedSessionTotal] = useState(1);
  const [leakedSessionSearch, setLeakedSessionSearch] = useState("");
  const [startDateLeakedSession, setStartDateLeakedSession] = useState("");
  const [endDateLeakedSession, setEndDateLeakedSession] = useState("");

  // Postman monitoring state variables
  const [postmanPage, setPostmanPage] = useState(1);
  const [postmanTotal, setPostmanTotal] = useState(1);
  const [postmanSearch, setPostmanSearch] = useState("");
  const [startDatePostman, setStartDatePostman] = useState("");
  const [endDatePostman, setEndDatePostman] = useState("");
  const [postmanRequestUrl, setPostmanRequestUrl] = useState("");
  const [postmanUrl, setPostmanUrl] = useState("");
  const [postmanUserDetails, setPostmanUserDetails] = useState("");
  const [postmanValue, setPostmanValue] = useState("");
  const [postmanSwaggerHub, setPostmanSwaggerHub] = useState(false);
  const [postmanApiVersion, setPostmanApiVersion] = useState("");
  const [postmanAuthentication, setPostmanAuthentication] = useState("");
  const [postmanRateLimit, setPostmanRateLimit] = useState("");
  const [leakedSessionFilter, setLeakedSessionFilter] = useState("all");
  const [leakedSessionDomain, setLeakedSessionDomain] = useState("all");
  const [editedData, setEditedData] = useState({
    name: "",
    dom: "",
    val: "",
    path: "/",
    fnd: "",
    expires: ""
  });



  const handleBulkDeleteMalware = () => {
    if (selectedMalwareIds.length > 0) {
      $.confirm({
        title: "Confirm Bulk Deletion",
        content: `Are you sure you want to delete ${selectedMalwareIds.length} selected items?`,
        type: "red",
        buttons: {
          delete: {
            text: "Yes, Delete All",
            btnClass: "btn-danger",
            keys: ["enter"],
            action: function () {
              const session = localStorage.getItem("session");
              axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

              axios.delete(`${API_URL}/getMalwareCredentials/${id}/bulkdelete`, {
                data: {
                  ids: selectedMalwareIds
                }
              })
                .then(response => {
                  if (response.data.error === false) {
                    toastr.success("Success", "Selected items deleted successfully");
                    setSelectedMalwareIds([]);
                    setMultiCheckTrue(false);
                    setMalwarePage(1);
                    fetchMalwareCredentials(id, dispatch, malwarePage, category, searchMalware, '', '', startDateMalware, endDateMalware, 10, 'desc');
                  } else {
                    toastr.error("Error", "Failed to delete selected items");
                  }
                })
                .catch(error => {
                  // console.error removed
                  toastr.error("Error", "Failed to delete selected items");
                });
            },
          },
          cancel: function () {
            // Do nothing on cancel
          },
        },
      });
    }
  };



  var ipCriticalityEnable = false;

  if (id == "62088cb69f0b0c58a632706a") {
    ipCriticalityEnable = true;
  }

  let table = useSelector((state) => state?.inventory?.ipdiscovery?.data?.data);
  let tableTotal = useSelector(
    (state) => state?.inventory?.ipdiscovery?.data?.totalRecords
  );
  let countRes = useSelector((state) => state?.inventory?.assetstotal?.data);
  let lengthOfPort = useSelector(
    (state) => state?.inventory?.allport?.data?.ports
  );
  let lengthOfLocation = useSelector(
    (state) => state?.inventory?.allcountry?.data?.countries
  );
  let lengthOfcloudLocations = useSelector(
    (state) => state?.inventory?.allcloud?.data?.cloudProviders
  );

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const authUser = useSelector(
    (state) => state?.auth?.user
  );
  let totalDataMob = useSelector(
    (state) => state?.fakeMobileApp?.mobileData?.data
  );

  let domain = client?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain.length - 1) == "/") {
    domain = [domain.substr(0, domain.length - 1)];
  } else {
    domain = [domain];
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
  }

  const hostOpen = (res) => {
    setHosts(res);
    setModalHost("Form Wizard modal host");
  };

  const riskOpen = (res) => {
    setHosts(res);
    setModalHost("Port Wizard modal host");
  };

  const state = useSelector(
    (state) => state?.fakeMobileApp?.mobileData?.data?.data
  );

  const stolenCredential = useSelector(
    (state) => state?.leakedCredential?.response?.data?.data
  );

  const stolenCredentialTotal = useSelector(
    (state) => state?.leakedCredential?.response?.data?.totalLeakedCredentials
  );


  let mapData = state;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }


  // End of Mobile
  // Beginnning of Source Code

  const [filterSourceData, setfilterSourceData] = useState("all");
  const [sourcepage, setSourcePage] = useState(1);
  const [sourceSearch, setSourceSearch] = useState("");
  const [sourcePageSize, setSourcePageSize] = useState(10);
  const sourceState = useSelector(
    (sourceState) => sourceState?.leakedCode?.data?.data
  );
  let currentSourceTableData = sourceState?.data;
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  //Beginning of Social Media Profile
  const [filterSocialData, setSocialfilterData] = useState("all");
  const [socialPage, setSocialPage] = useState(1);
  const [socialSearch, setSocialSearch] = useState("");
  const [socialTotal, setSocialTotal] = useState(1);
  const socialState = useSelector(
    (socialState) => socialState?.fakeMobileApp?.fakeSocialMedia?.data
  );

  let socialData = socialState?.data;

  let SocialPageSize = "";
  let currentSocialTableData = [];
  currentSocialTableData = socialState?.data;

  const darkwebList = useSelector(
    (state) => state?.darkweb?.response
  );

  // pastbin

  const [pasteTotal, setPasteTotal] = useState(1);
  const [pastePage, setPastePage] = useState(1);
  const [pasteBinSearch, setPasteBinSearch] = useState("");


  const pastebin = useSelector((state) => state?.pastebin?.response?.data);

  // Postman monitoring selectors
  const postmanData = useSelector((state) => state?.leakedCredential?.postman?.data);
  const postmanTotalCount = useSelector((state) => state?.leakedCredential?.postman?.totalCount);
  const postmanDetails = useSelector((state) => state?.leakedCredential?.postmandetails?.data);

  const snooze = (_id, event, option) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (option === "mob") {
      if (event === "markAsRemidiated") {
        $.confirm({
          title: "Are you sure?",
          content: "Do you really want to mark this as remediated for the mobile app?",
          type: "green",
          buttons: {
            ok: {
              text: "Yes, Mark as Remediated",
              btnClass: "btn-success",
              keys: ["enter"],
              action: function () {
                const data = {
                  action: "markAsRemediated",
                  lookalikeAppId: _id,
                  actionNote: "",
                  for: "forever",
                };
                fetchMobileRemidiatedFalseTrue(
                  id,
                  dispatch,
                  data,
                  page,
                  type,
                  category
                );
                setSelectedValue("pleaseSelect");
                setActionNote("");
              },
            },
            cancel: function () {
              // User canceled, do nothing
            },
          },
        });
      }
    }

    if (option === "source code") {
      if (event === "markAsRemidiated") {
        $.confirm({
          title: "Are you sure?",
          content: "Do you really want to mark this as remediated for the leaked code?",
          type: "green",
          buttons: {
            ok: {
              text: "Yes, Mark as Remediated",
              btnClass: "btn-success",
              keys: ["enter"],
              action: function () {
                const data = {
                  action: "markAsRemediated",
                  leakedCodeId: _id,
                  actionNote: "",
                  for: "forever",
                };
                fetchLeakedCodeAction(
                  id,
                  dispatch,
                  sourcepage,
                  filterSourceData,
                  "all",
                  data
                );
                setSelectedValue("pleaseSelect");
                setActionNote("");
              },
            },
            cancel: function () {
              // User canceled, do nothing
            },
          },
        });
      }
    }

    if (option === "social media") {
      if (event === "markAsRemidiated") {
        $.confirm({
          title: "Are you sure?",
          content: "Do you really want to mark this as remediated for the fake social media?",
          type: "green",
          buttons: {
            ok: {
              text: "Yes, Mark as Remediated",
              btnClass: "btn-success",
              keys: ["enter"],
              action: function () {
                const data = {
                  action: "markAsRemediated",
                  fakeSocialMediaId: _id,
                  actionNote: "",
                  for: "forever",
                };
                fetchSocailRemidiatedFalseTrue(id, dispatch, data, 1, socialPage);
                setSelectedValue("pleaseSelect");
                setActionNote("");
              },
            },
            cancel: function () {
              // User canceled, do nothing
            },
          },
        });
      }
    }

  };

  const storeName = (val) => {
    if (val == "iOS") return "iOS";
    else if (val == "Android" || val == "google") return "Android";
    else return "Third Party";
  };

  const addModal = (v) => {
    setSnoozeCon(v);
    setModal("Form Wizard modal");
  };

  const submit = () => {
    if (snoozeCon == "mob") {
      const data = {
        action: action,
        lookalikeAppId: lookalikeAppId,
        actionNote: actionNote,
        for: forValue,
      };
      fetchMobileRemidiatedFalseTrue(id, dispatch, data, 1, type, category);
      setModal("");
      setSelectedValue("pleaseSelect");
      setActionNote("");
    }
    if (snoozeCon == "source code") {
      const data = {
        action: action,
        leakedCodeId: lookalikeAppId,
        actionNote: actionNote,
        for: forValue,
      };
      fetchLeakedCodeAction(
        id,
        dispatch,
        sourcepage,
        filterSourceData,
        "all",
        data
      );
      setModal("");
      setSelectedValue("pleaseSelect");
      setActionNote("");
    }
    if (snoozeCon == "social media") {
      const data = {
        action: action,
        fakeSocialMediaId: lookalikeAppId,
        actionNote: actionNote,
        for: forValue,
      };
      fetchSocailRemidiatedFalseTrue(id, dispatch, data, page);
      setModal("");
      setSelectedValue("pleaseSelect");
      setActionNote("");
    }
  };

  const editModal = (row) => {
    setRepo(row);
    setModal("Form Wizard modal");
  };

  const auth = useSelector((state) => state?.auth?.user);

  // telegram

  const telegramtable = useSelector(
    (state) => state?.leakedCredential?.telegramData?.data?.data
  );

  const telegramtotal = useSelector(
    (state) => state?.leakedCredential?.telegramData?.data
  );

  // malware
  const malware = useSelector(
    (state) => state?.leakedCredential?.malware?.data
  );

  const pii = useSelector(
    (state) => state?.leakedCredential?.piidetails?.data
  );


  const stolenCredentials = useSelector(
    (state) => state?.leakedCredential?.response?.data?.data
  );

  const cloudDataTable = useSelector(
    (state) => state?.openCloud?.suspicious?.data
  );

  const leakedSessionData = useSelector(
    (state) => state?.leakedCredential?.sessions?.data?.data
  );

  const leakedSessionTotalCount = useSelector(
    (state) => state?.leakedCredential?.sessions?.data?.totalLeakedSessions
  );

  const [stolenLocation, setStolenLocation] = useState("");
  const [contenSource, setContenSource] = useState("");
  const [infringingIp, setInfringingIp] = useState("");
  const [rowId, setRowId] = useState("");
  const [isTakeDownModal, setTakeDownModal] = useState("");
  const brandMentionTable = useSelector((state) => state?.inventory?.brand);
  let brandMentionT = [];
  brandMentionT = brandMentionTable?.brandMentions;

  useEffect(() => {
    fetchDarkWebResult(id, dispatch, darkWebPage, category, startDateDarkWeb, endDateDarkWeb, 10)
  }, [id, darkWebPage, category, startDateDarkWeb, endDateDarkWeb, 10]);

  useEffect(() => {
    fetchIpDiscovery(
      id,
      dispatch,
      pageIpPorts,
      category,
      applyPortSearch,
      applyCountrySearch,
      applyCloudSearch,
      search,
      domainFilter,
      applyCriticality,
      limit
    );
  }, [
    id,
    dispatch,
    pageIpPorts,
    category,
    applyPortSearch,
    applyCountrySearch,
    applyCloudSearch,
    search,
    domainFilter,
    applyCriticality,
    limit
  ]);

  useEffect(() => {
    setPiiTotal(pii?.totalPersonalInformationLeakage)
  }, [pii?.totalPersonalInformationLeakage])

  useEffect(() => {
    brandMention(id, dispatch, brandMentionPage, category, brandMentionSearch, 10, "");
  }, [id, brandMentionPage, category, brandMentionSearch]);

  useEffect(() => {
    setBrandMentionTotal(brandMentionTable?.totalBrandMentions)
  }, [brandMentionTable?.totalBrandMentions])



  useEffect(() => {
    setTotalItemsIpPorts(tableTotal);
  }, [tableTotal]);

  useEffect(() => {
    allPort(id, dispatch, category);
  }, [id, dispatch, category]);

  useEffect(() => {
    allCountry(id, dispatch, category);
  }, [id, dispatch, category]);

  useEffect(() => {
    allCloud(id, dispatch, category);
  }, [id, dispatch, category]);



  useEffect(() => {
    fetchLeakedCredentials(id, dispatch, stolenPage, category, filterValue, searchStolen, '', '', startDateStolen, endDateStolen)
  }, [id, dispatch, stolenPage, category, filterValue, searchMalware, searchStolen, startDateStolen, endDateStolen])

  useEffect(() => {
    telegram(id, dispatch, telegramPage, category, startDateTelegram, endDateTelegram);
  }, [id, dispatch, telegramPage, category, startDateTelegram, endDateTelegram]);

  useEffect(() => {
    fetchFakeSocialMedia(
      id, dispatch, socialPage, category, platform, status, startDateSocial, endDateSocial, 10, socialSearch
    );
  }, [id, dispatch, socialPage, category, platform, status, startDateSocial, endDateSocial, socialSearch]);

  useEffect(() => {
    fetchLeakedCode(id, dispatch, sourcepage, filterSourceData, "all", startDateSource, endDateSource, 10, sourceSearch);
  }, [id, dispatch, sourcepage, filterSourceData, startDateSource, endDateSource, 10, sourceSearch]);

  useEffect(() => {
    fetchMalwareCredentials(id, dispatch, malwarePage, category, searchMalware, '', '', startDateMalware, endDateMalware, 10, 'desc');
  }, [id, dispatch, malwarePage, category, '', searchMalware, '', startDateMalware, endDateMalware])

  useEffect(() => {
    // Prefer email search if provided, else fallback to generic search
    const effectiveSearch = mobEmail?.trim() ? mobEmail.trim() : mobSearch;
    fetchMobileApp(id, dispatch, pageMob, filterData, category, startDateMobile, endDateMobile, 10, effectiveSearch);
  }, [id, dispatch, pageMob, filterData, category, startDateMobile, endDateMobile, mobSearch, mobEmail]);

  useEffect(() => {
    fetchPastebinResult(id, dispatch, pastePage, category, startDatePasteBin, endDatePasteBin, 10, pasteBinSearch);
  }, [id, dispatch, pastePage, category, startDatePasteBin, endDatePasteBin, pasteBinSearch]);


  useEffect(() => {
    // Load data based on active tab
    switch (activeTab) {
      case 'mobile':
        fetchMobileApp(id, dispatch, pageMob, filterData, category, startDateMobile, endDateMobile, 10, mobSearch);
        break;
      case 'source':
        fetchLeakedCode(id, dispatch, sourcepage, filterSourceData, "all", startDateSource, endDateSource, 10, sourceSearch);
        break;
      case 'social':
        fetchFakeSocialMedia(id, dispatch, socialPage, category, platform, status, startDateSocial, endDateSocial, 10, socialSearch);
        break;
      case 'darkweb':
        fetchDarkWebResult(id, dispatch, darkWebPage, category, startDateDarkWeb, endDateDarkWeb, 10);
        break;
      case 'telegram':
        telegram(id, dispatch, telegramPage, category, startDateTelegram, endDateTelegram);
        break;
      case 'pastebin':
        fetchPastebinResult(id, dispatch, pastePage, category, startDatePasteBin, endDatePasteBin, 10, pasteBinSearch);
        break;
      case 'malware':
        fetchMalwareCredentials(id, dispatch, malwarePage, category, '', searchMalware, '', '', startDateMalware, endDateMalware, 10, 'desc');
        break;
      case 'pii':
        fetchPiiDetails(id, dispatch, piiPage, category, searchPii, startDatePii, endDatePii);
        break;
      case 'stolen':
        fetchLeakedCredentials(id, dispatch, stolenPage, category, filterValue, searchStolen, '', '', startDateStolen, endDateStolen);
        break;
      case 'cloud':
        getSuspicousCloudData(id, dispatch, cloudPage, category, filterDataCloud, startDateCloud, endDateCloud,10,searchCloud);
        break;
      case 'brand':
        brandMention(id, dispatch, brandMentionPage, category, brandMentionSearch, 10);
        break;
      case 'ipOpenPorts':
        fetchIpDiscovery(
          id,
          dispatch,
          pageIpPorts,
          category,
          applyPortSearch,
          applyCountrySearch,
          applyCloudSearch,
          search,
          domainFilter,
          applyCriticality,
          limit
        );
        break;
      case 'leakedSessions':
        fetchLeakedSession(id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, "", startDateLeakedSession, endDateLeakedSession, 10);
        break;
    }
  }, [activeTab]);

  useEffect(() => {
    setTotalItemsMob(totalDataMob?.totalApps);
  }, [totalDataMob?.totalApps]);

  useEffect(() => {
    setTotalItemsSource(sourceState?.totalLeakedCodes);
  }, [sourceState?.totalLeakedCodes]);

  useEffect(() => {
    setStolenTotal(stolenCredentialTotal)
  }, [stolenCredentialTotal])

  useEffect(() => {
    setCloudTotal(cloudDataTable?.totalProfiles)
  }, [cloudDataTable?.totalProfiles])

  useEffect(() => {
    fetchPiiDetails(id, dispatch, piiPage, category, searchPii, startDatePii, endDatePii);
  }, [id, dispatch, piiPage, category, searchPii, startDatePii, endDatePii]);


  useEffect(() => {
    getSuspicousCloudData(id, dispatch, cloudPage, category, filterDataCloud, startDateCloud, endDateCloud, 10, searchCloud);
  }, [id, dispatch, cloudPage, category, filterDataCloud, startDateCloud, endDateCloud, searchCloud]);

  useEffect(() => {
    fetchLeakedSession(id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, "", startDateLeakedSession, endDateLeakedSession, 10);
  }, [id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, startDateLeakedSession, endDateLeakedSession]);


  useEffect(() => {
    setTelegramTotal(telegramtotal?.totalRecords)
  }, [telegramtotal?.totalRecords])


  useEffect(() => {
    setSocialTotal(socialState?.totalProfiles);
  }, [socialState?.totalProfiles]);


  useEffect(() => {
    setMalwareTotal(malware?.totalMalwareCredentials)
  }, [malware?.totalMalwareCredentials])

  useEffect(() => {
    setPasteTotal(pastebin?.totalApps);
  }, [pastebin?.totalApps]);


  useEffect(() => {
    setTotalItemsDarkWeb(darkwebList?.totalCount)
  }, [darkwebList?.totalCount])

  useEffect(() => {
    setLeakedSessionTotal(leakedSessionTotalCount)
  }, [leakedSessionTotalCount])

  // Postman monitoring useEffect hooks
  useEffect(() => {
    setPostmanTotal(postmanTotalCount)
  }, [postmanTotalCount])

  useEffect(() => {
    if (activeTab === 'postmanMonitoring') {
      postManDelta(id, dispatch, postmanPage, "all", startDatePostman, endDatePostman, limit);
    }
  }, [id, dispatch, postmanPage, activeTab, startDatePostman, endDatePostman, limit])

  useEffect(() => {
    if (activeTab === 'postmanMonitoring') {
      postManGraph(id, dispatch);
    }
  }, [id, dispatch, activeTab])

  // const fetchActions = {
  //   darkweb: () => fetchDarkWebResult(id, dispatch, darkWebPage, category, startDateDarkWeb, endDateDarkWeb),
  //   brand: () => brandMention(id, dispatch, brandMentionPage),
  //   stolen: () => fetchLeakedCredentials(id, dispatch, stolenPage, category, filterValue, searchStolen, '', '', startDateStolen, endDateStolen),
  //   telegram: () => telegram(id, dispatch, telegramPage, category, startDateTelegram, endDateTelegram),
  //   social: () => fetchFakeSocialMedia(id, dispatch, socialPage, category, platform, status, startDateSocial, endDateSocial),
  //   source: () => fetchLeakedCode(id, dispatch, sourcepage, filterSourceData, "all", startDateSource, endDateSource),
  //   malware: () => fetchMalwareCredentials(id, dispatch, malwarePage, category, '', searchMalware, '', '', startDateMalware, endDateMalware, 10, 'desc'),
  //   mobile: () => fetchMobileApp(id, dispatch, pageMob, filterData, category, startDateMobile, endDateMobile),
  //   pastebin: () => fetchPastebinResult(id, dispatch, pastePage, category, startDatePasteBin, endDatePasteBin),
  //   pii: () => fetchPiiDetails(id, dispatch, piiPage, category, searchPii, startDatePii, endDatePii),
  //   cloud: () => getSuspicousCloudData(id, dispatch, cloudPage, category, filterDataCloud, startDateCloud, endDateCloud),
  // };

  // const totalsSetters = [
  //   { key: "pii?.totalPersonalInformationLeakage", setter: setPiiTotal },
  //   { key: "brandMentionTable?.totalBrandMentions", setter: setBrandMentionTotal },
  //   { key: "totalDataMob?.totalApps", setter: setTotalItemsMob },
  //   { key: "sourceState?.totalLeakedCodes", setter: setTotalItemsSource },
  //   { key: "stolenCredentialTotal", setter: setStolenTotal },
  //   { key: "cloudDataTable?.totalProfiles", setter: setCloudTotal },
  //   { key: "telegramtotal?.totalRecords", setter: setTelegramTotal },
  //   { key: "socialState?.totalProfiles", setter: setSocialTotal },
  //   { key: "malware?.totalMalwareCredentials", setter: setMalwareTotal },
  //   { key: "pastebin?.totalApps", setter: setPasteTotal },
  //   { key: "darkwebList?.totalCount", setter: setTotalItemsDarkWeb },
  // ];

  // useEffect(() => {
  //   if (fetchActions[activeTab]) fetchActions[activeTab]();
  // }, [
  //   activeTab, id, dispatch, darkWebPage, category, filterValue, searchMalware, platform, status,
  //   startDateDarkWeb, endDateDarkWeb, pageMob, startDateMobile, endDateMobile, sourcepage, startDateSource, endDateSource,
  //   telegramPage, startDateTelegram, endDateTelegram, pastePage, startDatePasteBin, endDatePasteBin, malwarePage,
  //   startDateMalware, endDateMalware, piiPage, startDatePii, endDatePii, cloudPage, startDateCloud, endDateCloud, filterDataCloud
  // ]);

  // useEffect(() => {
  //   totalsSetters.forEach(({ key, setter }) => {
  //     const value = eval(key);
  //     setter(value);
  //   });
  // }, [
  //   pii?.totalPersonalInformationLeakage, brandMentionTable?.totalBrandMentions, totalDataMob?.totalApps,
  //   sourceState?.totalLeakedCodes, stolenCredentialTotal, cloudDataTable?.totalProfiles, telegramtotal?.totalRecords,
  //   socialState?.totalProfiles, malware?.totalMalwareCredentials, pastebin?.totalApps, darkwebList?.totalCount
  // ]);

  const toggleIcon = (_id, value) => {
    let val = toggleArray;
    if (val[_id]) {
      $("#" + _id + "_password").html("******");
      $("#" + _id + "_password_icon").attr("class", "fa fa-eye");
      // fa fa-eye-slash
      delete val[_id];
      setToggleArray({ ...val });
    } else {
      $("#" + _id + "_password").html(value);
      $("#" + _id + "_password_icon").attr("class", "fa fa-eye-slash");
      val[_id] = true;
      setToggleArray({ ...val });
    }
  };


  const takeDownValue = (res) => {
    let ip;
    res?.dnsDetails?.map((row) => {
      return Object.keys(row || {}).map((key) => {
        let record = row[key];
        if (record && record.length == 0) return false;
        if (key !== "dns_a") return false;
        record?.map((val) => {
          ip = val;
        });
      });
    });
    let originalWebsite = client.website;
    let domainName = res.host;
    ip = res.ip;
    setStolenLocation(originalWebsite);
    setContenSource(domainName);
    setInfringingIp(ip);
    setRowId(res._id);
    setTakeDownModal(true);
  };

  //   const submitTakeDownValue = () => {
  //   if (subject == "") {
  //     toastr.error("Error", "Subject cannot be empty.");
  //     return false;
  //   }
  //   if (stolenLocation == "") {
  //     toastr.error("Error", "Stolen location cannot be empty.");
  //     return false;
  //   }
  //   if (contenSource == "") {
  //     toastr.error("Error", "Content source cannot be empty.");
  //     return false;
  //   }
  //   if (infringingIp == "") {
  //     toastr.error("Error", "Infringin IP cannot be empty.");
  //     return false;
  //   }
  //   if (editorContent == "") {
  //     toastr.error("Error", "Editor content cannot be empty.");
  //     return false;
  //   }

  //   setTakeDownModal(false);
  //   takeDown(
  //     {
  //       subject,
  //       stolenLocation,
  //       contenSource,
  //       infringingIp,
  //       editorContent,
  //       rowId,
  //       id,
  //       page: "mobile"
  //     },
  //     dispatch
  //   );
  // };

  // update code all


  const [mobileModal, setMobileModal] = useState("");
  const [appName, setAppName] = useState("");
  const [appStoreUrl, setAppStoreUrl] = useState("");
  const [appStoreResource, setAppStoreResource] = useState("");
  const [upload, setupload] = useState("");
  const [appStoreSeverity, setAppStoreSeverity] = useState("");
  const [mobileId, setMobileId] = useState("");
  const [appStoreAttachment, setAppStoreAttachment] = useState("");
  const [attachmentUrl, setAttachmentUrl] = useState("");

  // mobile

  const updateMobile = (res) => {
    setMobileModal("Form Wizard modal")
    setMobileId(res?._id)
    setAppName(res?.app_name)
    setAppStoreUrl(res?.url)
    setAppStoreResource(res?.source)
    setAppStoreSeverity(res?.appStoreSeverity)
  }

  const deleteModule = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            fetchMobileAppDelete(id, _id, dispatch);
          },
        },
        cancel: function () {
        },
      },
    });
  };


  const clearAppStore = () => {
    setMobileId("")
    setMobileModal("")
    setAppName("")
    setAppStoreUrl("")
    setAppStoreResource("")
    setAppStoreSeverity("")
  };


  const submitMobileApplication = () => {
    let data = {
      app_name: appName,
      url: appStoreUrl,
      appStoreResource: appStoreResource,
      appStoreSeverity: appStoreSeverity,
      id: mobileId
    }
    fetchMobileAppUpdate(id, dispatch, data, clearAppStore, pageMob)
  }


  const handleLogoChange = (type) => (e) => {
    const fileName = e.target.files[0].name;
    setupload(fileName)
    Model.default.saveLogo(e.target.files[0]).then((response) => {
      if (!response.error) {
        let logo = response.data;
        if (type === "sourceCode")
          setAttachmentUrl(logo);
        else if (type === "mobileApp")
          setAppStoreAttachment(logo);
      }
    });
  }


  // source code

  const [sourceModal, setModalSource] = useState("");
  const [repoUrl, setRepoUrl] = useState("");
  const [programmingLanguage, setProgrammingLanguage] = useState("");
  const [severityLevel, setSourceCodeSeverity] = useState("");
  const [leakedCode, setLeakedCode] = useState("");
  const [sourceId, setSourceId] = useState("");

  const clearSourceStore = () => {
    setModalSource("")
    setSourceId("")
    setRepoUrl("")
    setProgrammingLanguage("")
    setSourceCodeSeverity("")
    setSourceCodeSeverity("")
    setLeakedCode("")
  };

  const updateSource = (res) => {
    setModalSource("Form Wizard modal source")
    setSourceId(res?._id)
    setRepoUrl(res?.repoUrl)
    setProgrammingLanguage(res?.programmingLanguage)
    setSourceCodeSeverity(res?.severityLevel)
    setLeakedCode(res?.leakedCode)
  }


  const submitSourceCode = () => {
    let data = {
      repoUrl: repoUrl,
      programmingLanguage: programmingLanguage,
      severityLevel: severityLevel,
      leakedCode: leakedCode,
      id: sourceId,
      isSuspicious: true,
    }
    fetchLeakedCodeUpdate(id, dispatch, data, clearSourceStore, sourcepage)
  }


  const deleteSource = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            fetchLeakedCodeDelete(id, _id, dispatch, sourcepage);
          },
        },
        cancel: function () {
        },
      },
    });
  };

  // social media profile

  const [socialModal, setModalSocial] = useState("");
  const [fakePageUrl, setFakePageUrl] = useState("");
  const [socialId, setsocialId] = useState("");
  const [socialMediaPlatform, setSocialMediaPlatform] = useState("");
  const [socialSeverity, setSocialSeverity] = useState("");
  const [socialComments, setSocialComments] = useState("");
  const [socialAttachment, setSocialAttachment] = useState("");


  const clearSocialMedia = () => {
    setModalSocial("")
    setFakePageUrl("")
    setsocialId("")
    setSocialMediaPlatform("")
    setSocialSeverity("")
    setSocialComments("")
    setSocialAttachment("")
  };

  const deleteSocial = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            fetchFakeSocialMediaDelete(id, _id, dispatch, socialPage);
          },
        },
        cancel: function () {
        },
      },
    });
  };

  const updateSocial = (res) => {
    setModalSocial("Form Wizard modal social")
    setsocialId(res?._id)
    setFakePageUrl(res?.link)
    setSocialMediaPlatform(res?.source)
  }

  const submitSocialMedia = () => {
    let data = {
      fakePageUrl: fakePageUrl,
      socialMediaPlatform: socialMediaPlatform,
      socialSeverity: socialSeverity,
      socialComments: socialComments,
      // socialAttachment: socialAttachment,
      id: socialId,
      isSuspicious: true,
    }
    fetchFakeSocialMediaUpdate(id, dispatch, data, clearSocialMedia, socialPage)
  }


  // darkweb
  const [darkWebModal, setModalDarkWeb] = useState("");
  const [darkWebId, setDarkWebId] = useState("");
  const [titleDarkWeb, setTitleDarkWeb] = useState("");
  const [threadLinkDarkWeb, setThreadLinkDarkWeb] = useState("");
  const [authorNameDarkWeb, setAuthorNameDarkWeb] = useState("");
  // const [sourceDarkWeb, setSourceDarkWeb] = useState("");
  const [authorLinkDarkWeb, setAuthorLinkDarkWeb] = useState("");
  const [authorDarkWeb, setAuthorDarkWeb] = useState("");
  const [dateDarkWeb, setDateDarkWeb] = useState("");
  const [darkWebAttachmentUrl, setDarkWebAttachmentUrl] = useState("");
  // const [SourceDarkWeb, setSourceDarkWeb] = useState("");
  const [sourceSourceDarkWeb, setSourceDarkWeb] = useState("");




  const updateDarkWeb = (row) => {
    setDarkWebId(row?._id)
    setModalDarkWeb("Form Wizard modal dark web");
    setDarkWebAttachmentUrl(row?.fixed_screenshot_path)
    setDarkWebAttachmentUrl(row?.fullpage_screenshot_url)
    setSourceDarkWeb(row?.source)
    setAuthorLinkDarkWeb(row?.author_link)
    setThreadLinkDarkWeb(row?.thread_link)
    setTitleDarkWeb(row?.title)
    setAuthorNameDarkWeb(row?.author_name)
    setDateDarkWeb(row?.date)
  }

  const deleteDarkWeb = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            fetchDarkWebDelete(id, _id, dispatch, darkWebPage);
          },
        },
        cancel: function () {
        },
      },
    });
  };

  const clearDarkWebData = () => {
    setModalDarkWeb("");
    setTitleDarkWeb("");
    setThreadLinkDarkWeb("");
    setAuthorNameDarkWeb("");
    setSourceDarkWeb("");
    setAuthorLinkDarkWeb("");
    setAuthorDarkWeb("");
    setDateDarkWeb("");
    setDarkWebAttachmentUrl("");
  };

  const submitDarkWebData = () => {
    const data = {
      "title": titleDarkWeb,
      "thread_link": threadLinkDarkWeb,
      "author_name": authorNameDarkWeb,
      "date": dateDarkWeb,
      "fixed_screenshot_path": darkWebAttachmentUrl,
      "fullpage_screenshot_url": darkWebAttachmentUrl,
      "source": sourceSourceDarkWeb,
      "author_link": authorLinkDarkWeb,
      "author": authorDarkWeb,
      "id": darkWebId
    };
    fetchDarkWebResultUpdate(id, dispatch, data, clearDarkWebData, darkWebPage)
  };

  // telegram


  const [groupname, setGroupName] = useState("");
  const [modalTelegram, setModalTelegram] = useState("");
  const [telegramId, setTelegramId] = useState("");
  const [message, setMessage] = useState("");
  const [telegramDate, setTelegramDate] = useState("");
  const [messagelink, setMessageLink] = useState("");
  const [telegramImg, setTelegramImg] = useState("");

  const formatDateToLocal = (dateStr) => {
    if (!dateStr) return '';

    const [date, time] = dateStr.split(' ');
    if (!date || !time) return '';

    const [day, month, year] = date.split('-');
    if (!day || !month || !year) return '';

    let [hour, minute] = time.split(':');
    if (!hour || !minute) return '';

    const ampm = time.slice(-2);
    if (ampm === 'PM' && hour < 12) {
      hour = parseInt(hour) + 12;
    } else if (ampm === 'AM' && hour === '12') {
      hour = '00';
    }

    return `${year}-${month}-${day}T${hour}:${minute.slice(0, 2)}`;
  };

  const clearTelegram = () => {
    setModalTelegram("")
    setTelegramId("")
    setGroupName("");
    setMessage("");
    setTelegramDate("");
    setMessageLink("");
    setTelegramImg("");
  };



  const updateTelegram = (row) => {
    setModalTelegram("Form Wizard modal Telegram");
    setGroupName(row?.group_name);
    setMessageLink(row?.message_link);
    setTelegramId(row?._id);
    setMessage(row?.message);
    setTelegramDate(new Date(row?.date).toISOString().split('T')[0]);
  }


  const deleteTelegram = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            telegramDelete(id, dispatch, _id);
          },
        },
        cancel: function () {
        },
      },
    });
  };


  const submitTelegram = () => {
    let data = {
      date: telegramDate,
      group_name: groupname,
      message_link: messagelink,
      isRemidiated: false,
      message: message,
      id: telegramId,
      s3_media_url: telegramImg
    }
    telegramUpdate(id, dispatch, data, clearTelegram, telegramPage)
  }


  // pastebin search

  const [pastbinModal, setPastbinModal] = useState("");
  const [title, setTitle] = useState("");
  const [snippet, setSnippet] = useState("");
  const [pasteBinId, setPasteBinId] = useState("");
  const [date, setDate] = useState("");
  const [link, setLink] = useState("");



  const deletePasteBin = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            pastebinDelete(id, dispatch, _id);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const updatePasteBin = (row) => {
    setPastbinModal("Form Wizard modal pastebin");
    setPasteBinId(row?._id)
    setTitle(row?.title);
    setSnippet(row?.snippet);
    setLink(row?.link)
  }

  const clearPastBin = () => {
    setPastbinModal("");
    setTitle("");
    setSnippet("");
    setPasteBinId("");
    setDate("");
    setLink("");
  };

  const submitPastbinSearch = () => {
    let data = {
      title: title,
      snippet: snippet,
      link: link,
      id: pasteBinId,
      date: date
    }
    pastebinUpdate(id, dispatch, data, clearPastBin, pastePage)
  }


  // malware

  const [createdAt, setCreatedAt] = useState("");
  const [usr, setUsr] = useState("");
  const [src, setSrc] = useState("");
  const [mal, setMal] = useState("");
  const [pwd, setPwd] = useState("");
  const [iip, setIip] = useState("");
  const [hid, setHid] = useState("");
  const [fnd, setFnd] = useState("");
  const [modalMalware, setModalMalware] = useState("");
  const [malwareId, setMalwareId] = useState("");


  const clearMalware = () => {
    setModalMalware("")
    setCreatedAt("");
    setUsr("");
    setSrc("");
    setMal("");
    setPwd("");
    setIip("");
    setHid("");
    setFnd("");
  };

  const updateMalware = (row) => {
    setModalMalware("Form Wizard modal Malware")
    setCreatedAt(new Date(row?.createdAt).toISOString().split('T')[0])
    setUsr(row?.usr)
    setSrc(row?.src)
    setMal(row?.mal)
    setPwd(row?.pwd)
    setIip(row?.iip)
    setHid(row?.hid)
    setFnd(row?.fnd)
    setMalwareId(row?._id)
  }


  const deleteMalware = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            malwareCredentialsDelete(id, _id, dispatch)
            setMalwarePage(1);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const submitMalware = () => {
    setMalwarePage(1)
    const data = {
      createdAt: createdAt,
      usr: usr,
      src: src,
      mal: mal,
      pwd: pwd,
      iip: iip,
      hid: hid,
      fnd: fnd,
      id: malwareId
    };
    malwareCredentialsUpdate(id, dispatch, data, clearMalware, malwarePage);
  }

  // stolen credentials
  const [modalStolen, setModalStolen] = useState("");
  const [eml, setEml] = useState("");
  const [idStolen, setStolenId] = useState("");
  const [srcMalware, setSrcMalware] = useState("");
  const [createdAtMalware, setCreatedAtMalware] = useState("");
  const [pwdMalware, setMalware] = useState("");
  const [stolenCredentialType, setStolenCredentialType] = useState("");


  const updateStolen = (row) => {
    setModalStolen("Form Wizard modal Stolen");
    setStolenId(row?._id)
    setEml(row?.eml);
    setSrcMalware(row?.src);
    setCreatedAtMalware(new Date(row?.createdAt).toISOString().split('T')[0]);
    setMalware(row?.pwd);
    setStolenCredentialType(row?.type || "");
  }

  const clearStolen = () => {
    setModalStolen("");
    setStolenId("")
    setEml("");
    setSrcMalware("");
    setCreatedAtMalware("");
    setMalware("");
    setStolenCredentialType("");
  }

  const deleteStolen = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            leakedCredentialsDelete(id, dispatch, _id);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const submitStolen = () => {
    let data = {
      id: idStolen,
      eml,
      src: srcMalware,
      createdAt: new Date(createdAtMalware)?.toISOString(),
      pwd: pwdMalware,
      type: stolenCredentialType
    }
    leakedCredentialsUpdate(id, dispatch, data, clearStolen, stolenPage);
  }

  // brand Mention

  const [updatedAt, setUpdatedAt] = useState("");
  const [host, setHost] = useState("");
  const [brandMentionModal, setBrandMentionModal] = useState("");
  const [brandMentionId, setBrandMentionId] = useState("");


  const updateBrandMention = (row) => {
    setBrandMentionModal("Form Wizard modal Brand");
    setHost(row?.subDomainName);
    setBrandMentionId(row?._id);
    setUpdatedAt(new Date(row?.updatedAt).toISOString().split('T')[0]);
  }

  const brandMentionClear = () => {
    setBrandMentionModal("");
    setHost("");
    setBrandMentionId("");
    setUpdatedAt("");
  }


  const deleteBrandMention = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            brandMentionDelete(id, _id, dispatch, category, brandMentionSearch);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const submitBrandMention = () => {
    let data = {
      subDomainName: host,
      updatedAt: new Date(updatedAt)?.toISOString(),
      id: brandMentionId
    }
    brandMentionUpdate(id, dispatch, data, brandMentionClear, category, brandMentionSearch)
  }




  // pii
  const [piiModal, setPiiModal] = useState("");
  const [piiId, setPiiIdd] = useState("");
  const [email, setEmail] = useState("");
  const [ip_address, setIp_address] = useState("");
  const [username, setUsername] = useState("");
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [database_name, setDatabase_name] = useState("");
  const [createdAtDate, setCreatedAtDate] = useState("");


  const clearPii = () => {
    setPiiModal("");
    setCreatedAtDate("");
    setUsr("");
    setSrc("");
    setMal("");
    setPwd("");
    setIip("");
    setHid("");
    setFnd("");
  };

  const updatePii = (row) => {
    setPiiModal("Form Wizard modal pii");
    setPiiIdd(row?._id);
    setEmail(row?.email);
    setIp_address(row?.ip_address);
    setUsername(row?.username);
    setAddress(row?.address);
    setPhone(row?.phone);
    setDatabase_name(row?.database_name);
    setCreatedAtDate(new Date(row?.createdAt).toISOString().split('T')[0]);
  };

  const deletePii = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            piiDelete(id, dispatch, _id)
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const submitPii = () => {
    let data = {
      _id: piiId,
      database_name,
      createdAt: new Date(createdAtDate)?.toISOString(),
      phone,
      mal,
      address,
      username,
      ip_address,
      email
    }
    piiUpdateById(id, dispatch, data, clearPii, piiPage)
  }

  // Cloud Bucket


  const [bucket, setBucket] = useState("");
  const [fullPath, setFullPath] = useState("");
  const [size, setSize] = useState("");
  const [type, setType] = useState("");
  const [filename, setFilename] = useState("");
  const [url, setUrl] = useState("");
  const [updateAt, setUpdatedAtCloud] = useState("");
  const [cloudBucketModalModal, setCloudBucketModal] = useState("");
  const [cloudBucketId, setCloudBucketId] = useState("");



  const updateCloudBucket = (row) => {
    setCloudBucketModal("Form Wizard modal cloud");
    setCloudBucketId(row?._id)
    setBucket(row?.bucket);
    setFullPath(row?.fullPath);
    setSize(row?.size);
    setUrl(row?.url);
    setFilename(row?.filename);
    setUpdatedAtCloud(new Date(row?.updateAt).toISOString().split('T')[0]);
  }

  const clearCloudBucket = () => {
    setCloudBucketModal("");
    setCloudBucketId("")
    setBucket("");
    setFullPath("");
    setSize("");
    setUrl("");
    setFilename("");
    setUpdatedAtCloud("");
  }

  const deleteCloudBucket = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            cloudBucketDeleteById(id, _id, dispatch)
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const submitCloud = () => {
    let data = {
      id: cloudBucketId,
      bucket, fullPath, size, type, filename, url, updatedAt: new Date(updateAt)?.toISOString()
    }
    cloudUpdateById(id, dispatch, data, clearCloudBucket, cloudPage)
  }

  // assets & ip
  const [ipOpenModal, setIpOpenModal] = useState("");
  const [ipId, setIpId] = useState("");


  const addValue = (id) => {
    const inputValue = document.getElementById(id).value;

    if (inputValue.trim() === "") {
      const errorMessages = {
        hosts: "Please enter a host.",
        impacts: "Please enter an impact.",
        networkServices: "Please enter a network service.",
        openPorts: "Please enter an open port.",
        recommendations: "Please enter a recommendation.",
      };
      toastr.error(errorMessages[id] || "Input cannot be empty!");
      return; // Avoid adding empty values
    }

    switch (id) {
      case "hosts":
        setHosts([...hosts, inputValue]);
        break;
      case "impacts":
        setImpacts([...impacts, inputValue]);
        break;
      case "networkServices":
        setNetworkServices([...networkServices, inputValue]);
        break;
      case "openPorts":
        setOpenPorts([...openPorts, inputValue]);
        break;
      case "recommendations":
        setRecommendations([...recommendations, inputValue]);
        break;
      default:
        break;
    }

    document.getElementById(id).value = ""; // Clear the input field
  };

  const removeValue = (id, index) => {
    switch (id) {
      case "hosts":
        setHosts(hosts.filter((_, i) => i !== index));
        break;
      case "impacts":
        setImpacts(impacts.filter((_, i) => i !== index));
        break;
      case "networkServices":
        setNetworkServices(networkServices.filter((_, i) => i !== index));
        break;
      case "openPorts":
        setOpenPorts(openPorts.filter((_, i) => i !== index));
        break;
      case "recommendations":
        setRecommendations(recommendations.filter((_, i) => i !== index));
        break;
      default:
        break;
    }
  };

  const updateIpdiscoveryOpenPorts = (data) => {
    setIpOpenModal("Form Wizard modal ip");
    setIpId(data?._id)
    setCloudOrISPProvider(data?.cloudOrISPProvider || '');
    setHighestSeverity(data?.highestSeverity || '');
    setIp(data?.ip || '');
    setLocation(data?.location || '');
    setSubdomains(data?.subdomains || '');
    setOperatingSystem(data?.operatingSystem || '');
    const formatDate = (dateString) => {
      if (!dateString) return '';
      return new Date(dateString).toISOString().split('T')[0];
    };
    setUpdatedAtIp(formatDate(data?.updatedAt));
    setCreatedAtIp(formatDate(data?.createdAt));
    setHosts(data?.hosts?.filter(Boolean) || []);
    setImpacts(data?.impacts?.filter(Boolean) || []);
    setNetworkServices(data?.networkServices?.filter(Boolean) || []);
    setOpenPorts(data?.openPorts?.filter(Boolean) || []);
    setRecommendations(data?.recommendations?.filter(Boolean) || []);
  }

  const clearPortsIp = () => {
    setIpOpenModal();
    setHosts([]);
    setImpacts([]);
    setNetworkServices([]);
    setOpenPorts([]);
    setRecommendations([]);
    setCloudOrISPProvider("");
    setHighestSeverity("");
    setIp("");
    setLocation("");
    setSubdomains("");
    setOperatingSystem("");
    setOperatingSystem("");
    setCreatedAtIp("");
    setUpdatedAtIp("");
  }

  const submitIpOpernPorts = () => {
    // if (cloudOrISPProvider == "") {
    //   toast("Please enter cloud or isp provider.");
    //   return;
    // }
    // if (highestSeverity == "" ) {
    //   toast("Please enter highest serverity.");
    //   return;
    // }
    // if (ip == "") {
    //   toast("Please enter ip.");
    //   return;
    // }
    // if (location == "") {
    //   toast("Please enter location.");
    //   return;
    // }
    // if (subdomains == "") {
    //   toast("Please enter subdomain.");
    //   return;
    // }
    // if (operatingSystem == "") {
    //   toast("Please enter operating system.");
    //   return;
    // }
    // if (createdAtIp == "") {
    //   toast("Please enter created at.");
    //   return;
    // }
    // if (updatedAtIp == "") {
    //   toast("Please enter updated at.");
    //   return;
    // }
    // if (hosts.length === 0) {
    //   toast("Please add at least one host.");
    //   return;
    // }
    // if (impacts.length === 0) {
    //   toast("Please add at least one impact.");
    //   return;
    // }
    // if (networkServices.length === 0) {
    //   toast("Please add at least one network service.");
    //   return;
    // }
    // if (openPorts.length === 0) {
    //   toast("Please add at least one open port.");
    //   return;
    // }
    // if (recommendations.length === 0) {
    //   toast("Please add at least one recommendation.");
    //   return;
    // }
    updateIpPorts(id,
      {
        hosts,
        impacts,
        networkServices,
        openPorts,
        recommendations,
        location,
        ip,
        createdAt: new Date(createdAtIp)?.toISOString(),
        updateAt: new Date(updatedAtIp)?.toISOString(),
        highestSeverity,
        cloudOrISPProvider,
        operatingSystem,
        subdomains,
        // organisationId: id,
        id: ipId
      },
      clearPortsIp, dispatch)
  }

  const deleteipAssets = (_id) => {
    $.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this ?",
      type: "red",
      buttons: {
        delete: {
          text: "Yes, Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            assetsIpDelete(id, _id, dispatch, category);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  // Leaked Session Functions
  const openEditLeakedSession = (row) => {
    setEditedData(row);
    setModal('editLeakedSession');
  };

  const addNewLeakedSession = () => {
    clearLeakedSession();
    setModal('editLeakedSession');
  };

  const deleteLeakedSession = (_id) => {
    $.confirm({
      title: "Are you sure?",
      content: "Do you want to delete this record?",
      type: "red",
      typeAnimated: true,
      buttons: {
        confirm: {
          text: "Confirm",
          btnClass: "btn-red",
          action: function () {
            // Try direct delete endpoint, fallback to action API if fails
            deleteLeakedSessionAPI(id, _id, () => {
              fetchLeakedSession(id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, "", startDateLeakedSession, endDateLeakedSession, 10);
            });
          },
        },
        cancel: function () {
          // Cancelled
        },
      },
    });
  };

  const clearLeakedSession = () => {
    setEditedData({
      name: "",
      dom: "",
      val: "",
      path: "/",
      fnd: "",
      expires: ""
    });
  };

  const submitLeakedSession = () => {
    if (!editedData?.name || !editedData?.dom || !editedData?.val) {
      toastr.error("Error", "Name, Domain, and Value are required fields");
      return;
    }

    const formattedData = {
      ...editedData,
      expires: editedData.expires ? (() => {
        const date = new Date(editedData.expires);
        if (isNaN(date.getTime())) {
          return undefined;
        }
        return Math.floor(date.getTime() / 1000); // backend originally used epoch seconds
      })() : undefined
    };

    // Remove undefined / empty string fields
    Object.keys(formattedData).forEach(key => {
      if (formattedData[key] === undefined || formattedData[key] === "") {
        delete formattedData[key];
      }
    });

    // Check if this is an edit operation (has _id) or add operation
    if (editedData?._id) {
      // Update existing session: call direct endpoint; if it fails, fallback to action API (legacy)
      const refresh = () => {
        clearLeakedSession();
        setModal("");
        fetchLeakedSession(id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, "", startDateLeakedSession, endDateLeakedSession, 10);
      };
      // Primary path
      let directCalled = false;
      try {
        const maybePromise = updateLeakedSession(id, editedData._id, formattedData, () => {
          directCalled = true;
          refresh();
        });
        if (maybePromise && typeof maybePromise.then === 'function') {
          maybePromise.catch(() => {
            if (!directCalled) {
              const legacy = { action: "update", leakedSessionIds: [editedData._id], data: formattedData };
              fetchLeakedSessionAction(
                id,
                dispatch,
                leakedSessionPage,
                leakedSessionFilter,
                leakedSessionSearch,
                category,
                legacy
              );
              refresh();
            }
          });
        }
      } catch (e) {
        const legacy = { action: "update", leakedSessionIds: [editedData._id], data: formattedData };
        fetchLeakedSessionAction(
          id,
          dispatch,
          leakedSessionPage,
          leakedSessionFilter,
          leakedSessionSearch,
          category,
          legacy
        );
        refresh();
      }
    } else {
      // Add new session
      addLeakedSession(id, {
        data: [formattedData],
        callback: () => {
          clearLeakedSession();
          setModal("");
          fetchLeakedSession(id, dispatch, leakedSessionPage, leakedSessionFilter, leakedSessionSearch, category, leakedSessionDomain, "", startDateLeakedSession, endDateLeakedSession, 10);
        }
      });
    }
  };



  const mobileAppColumns = [
    {
      header: 'Application Name',
      field: 'applicationName'
    },
    {
      header: 'Package Name',
      field: 'packageName'
    },
    {
      header: 'Store',
      field: 'store'
    },
    {
      header: 'Version',
      field: 'version'
    },
    {
      header: 'Last Updated',
      field: 'lastUpdated',
      format: (value) => value ? moment(value).format('DD-MM-YYYY') : 'NA'
    }
  ];

  const sourceCodeColumns = [
    {
      header: 'Repository Name',
      field: 'repositoryName'
    },
    {
      header: 'URL',
      field: 'url',
      format: (value) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      )
    },
    {
      header: 'Last Commit',
      field: 'lastCommit',
      format: (value) => value ? moment(value).format('DD-MM-YYYY') : 'NA'
    }
  ];

  const socialMediaColumns = [
    {
      header: 'Platform',
      field: 'platform'
    },
    {
      header: 'Profile Name',
      field: 'profileName'
    },
    {
      header: 'URL',
      field: 'url',
      format: (value) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      )
    },
    {
      header: 'Last Activity',
      field: 'lastActivity',
      format: (value) => value ? moment(value).format('DD-MM-YYYY') : 'NA'
    }
  ];


  // Selection handlers for malware credentials table
  const malwareColumns = [
    {
      header: (
        <input
          type="checkbox"
          checked={multiCheckTrue}
          onClick={handleSelectAllMalware}
          className="checkUncheck"
        />
      ),
      field: '_id',
      format: (value) => (
        <input
          type="checkbox"
          checked={selectedMalwareIds.includes(value)}
          onClick={() => handleSelectMalware(value)}
          className="checkUncheck"
        />
      )
    },
    {
      header: 'Found on',
      field: 'fnd',
      format: (value) => moment(value).format('DD-MM-YYYY')
    },
    {
      header: 'User',
      field: 'usr'
    },
    {
      header: 'Password',
      field: 'pwd'
    },
    {
      header: 'Url',
      field: 'src'
    },
    {
      header: 'Malware Type',
      field: 'mal'
    },
    {
      header: 'Infected IP',
      field: 'iip'
    },
    {
      header: 'Hardware ID',
      field: 'hid'
    }
  ];

  const piiColumns = [
    {
      header: 'Email',
      field: 'email'
    },
    {
      header: 'Password',
      field: 'password'
    },
    {
      header: 'Source',
      field: 'source'
    },
    {
      header: 'Date',
      field: 'createdAt',
      format: (value) => moment(value).format('DD-MM-YYYY')
    }
  ];

  const telegramColumns = [
    {
      header: 'Message',
      field: 'message'
    },
    {
      header: 'Telegram Group',
      field: 'telegramGroup'
    },
    {
      header: 'Message Link',
      field: 'messageLink'
    },
    {
      header: 'Chat Detail',
      field: 'chatDetail'
    },
    {
      header: 'Date',
      field: 'createdAt',
      format: (value) => moment(value).format('DD-MM-YYYY')
    }
  ];

  const darkWebColumns = [
    {
      header: '#No',
      field: 'index',
      format: (_, row, index) => (page - 1) * 10 + 1 + index
    },
    {
      header: 'Title',
      field: 'title',
      format: (value, row) => {
        if (!row) return 'N/A';
        return (
          <a
            href={row?.thread_link || '#'}
            target="_blank"
            style={{
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
            }}
          >
            {value || "N/A"}
          </a>
        );
      }
    },
    {
      header: 'Author name',
      field: 'author_name',
      format: (value, row) => {
        if (!row) return 'N/A';
        return (
          <a href={row?.author_url || '#'} target="_blank">
            {value || 'N/A'}
          </a>
        );
      }
    },
    {
      header: 'Date',
      field: 'createdAt',
      format: (value) => value ? moment(value).format('DD-MM-YYYY') : 'N/A'
    },
    {
      header: 'Screenshot Path',
      field: 'screenshot_path',
      format: (value) => {
        if (!value) return 'N/A';
        return (
          <Fancybox
            options={{
              Carousel: {
                infinite: false,
              },
            }}
          >
            <a
              data-fancybox="gallery"
              href={value}
            >
              <img
                alt=""
                src={value}
                style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover'
                }}
              />
            </a>
          </Fancybox>
        );
      }
    },
    {
      header: 'Source',
      field: 'source',
      format: (value) => value || 'N/A'
    }
  ];

  // Add state for active bulk delete table
  const [activeBulkDelete, setActiveBulkDelete] = useState('');

  // Add state for bulk deletion
  const [selectedItems, setSelectedItems] = useState({
    mobileApp: [],
    sourceCode: [],
    socialMedia: [],
    darkWeb: [],
    telegram: [],
    pastebin: [],
    malware: [],
    pii: [],
    stolen: [],
    leakedSession: [],
    cloudBucket: [],
    brandMention: [],
    ipDiscovery: [],
    postman: []
  });

  // Handle select all checkbox
  const handleSelectAll = (tableType, items) => {
    if (selectedItems[tableType].length === items.length) {
      setSelectedItems({ ...selectedItems, [tableType]: [] });
    } else {
      setSelectedItems({ ...selectedItems, [tableType]: items.map(item => item._id) });
    }
  };

  // Handle individual checkbox selection
  const handleSelectItem = (tableType, itemId) => {
    const newSelected = selectedItems[tableType].includes(itemId)
      ? selectedItems[tableType].filter(id => id !== itemId)
      : [...selectedItems[tableType], itemId];
    setSelectedItems({ ...selectedItems, [tableType]: newSelected });
  };

  // Bulk delete function
  const handleBulkDelete = (tableType) => {
    if (selectedItems[tableType].length === 0) return;

    $.confirm({
      title: "Confirm Bulk Deletion",
      content: `Are you sure you want to delete ${selectedItems[tableType].length} selected items?`,
      type: "red",
      buttons: {
        deleteBtn: {
          text: "Yes, Delete All",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            // Call APIs directly without individual confirmation dialogs
            switch (tableType) {
              case 'mobileApp':
                selectedItems[tableType].forEach(itemId => {
                  fetchMobileAppDelete(id, itemId, dispatch);
                });
                break;
              case 'sourceCode':
                selectedItems[tableType].forEach(itemId => {
                  fetchLeakedCodeDelete(id, itemId, dispatch);
                });
                break;
              case 'socialMedia':
                selectedItems[tableType].forEach(itemId => {
                  fetchFakeSocialMediaDelete(id, itemId, dispatch);
                });
                break;
              case 'darkWeb':
                selectedItems[tableType].forEach(itemId => {
                  fetchDarkWebDelete(id, itemId, dispatch);
                });
                break;
              case 'telegram':
                selectedItems[tableType].forEach(itemId => {
                  telegramDelete(id, itemId, dispatch);
                });
                break;
              case 'pastebin':
                selectedItems[tableType].forEach(itemId => {
                  pastebinDelete(id, itemId, dispatch);
                });
                break;
              case 'malware':
                selectedItems[tableType].forEach(itemId => {
                  malwareCredentialsDelete(id, itemId, dispatch);
                });
                setMalwarePage(1);
                break;
              case 'pii':
                selectedItems[tableType].forEach(itemId => {
                  piiDelete(id, itemId, dispatch);
                });
                break;
              case 'stolen':
                selectedItems[tableType].forEach(itemId => {
                  leakedCredentialsDelete(id, itemId, dispatch);
                });
                break;
              case 'leakedSession':
                selectedItems[tableType].forEach(itemId => {
                  leakedCredentialsDelete(id, itemId, dispatch);
                });
                break;
              case 'cloudBucket':
                selectedItems[tableType].forEach(itemId => {
                  cloudBucketDeleteById(id, itemId, dispatch);
                });
                break;
              case 'brandMention':
                selectedItems[tableType].forEach(itemId => {
                  brandMentionDelete(id, itemId, dispatch);
                });
                break;
              case 'ipDiscovery':
                selectedItems[tableType].forEach(itemId => {
                  assetsIpDelete(id, itemId, dispatch);
                });
                break;
              case 'postman':
                selectedItems[tableType].forEach(itemId => {
                  // Direct API call for postman deletion
                  axios.delete(`${API_URL}/postmanRecord/${itemId}?organisationId=${id}`)
                    .then((response) => {
                      if (response.data.error === false) {
                      }
                    })
                    .catch((error) => {
                      // console.error removed
                    });
                });
                break;
            }

            // Show success message
            toastr.success("Success", `${selectedItems[tableType].length} items deleted successfully`);

            // Clear selection after deletion
            setSelectedItems({ ...selectedItems, [tableType]: [] });

            // Refresh the data based on table type
            setTimeout(() => {
              switch (tableType) {
                case 'mobileApp':
                  setPageMob(1);
                  break;
                case 'sourceCode':
                  setSourcePage(1);
                  break;
                case 'socialMedia':
                  setSocialPage(1);
                  break;
                case 'darkWeb':
                  setDarkWebPage(1);
                  break;
                case 'telegram':
                  setTelegramPage(1);
                  break;
                case 'pastebin':
                  setPastePage(1);
                  break;
                case 'malware':
                  setMalwarePage(1);
                  break;
                case 'pii':
                  setPiiPage(1);
                  break;
                case 'stolen':
                  setStolenPage(1);
                  break;
                case 'leakedSession':
                  setLeakedSessionPage(1);
                  break;
                case 'cloudBucket':
                  setCloudPage(1);
                  break;
                case 'brandMention':
                  setBrandMentionPage(1);
                  break;
                case 'ipDiscovery':
                  setPageIpPorts(1);
                  break;
                case 'postman':
                  setPostmanPage(1);
                  break;
              }
            }, 1000);
          },
        },
        cancel: function () { },
      },
    });
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Reset all pagination
    setPage(1);
    setPageMob(1);
    setPastePage(1);
    setPiiPage(1);
    setCloudPage(1);
    setSocialPage(1);
    setSourcePage(1);
    setStolenPage(1);
    setDarkWebPage(1);
    setLeakedSessionPage(1);
    history.push(`${locationUse.pathname}?tab=${tab}`);
  };

  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPageIpPorts(1);
  };

  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Postman monitoring functions
  const updatePostman = (row) => {
    setPostmanRequestUrl(row?.request_url || "");
    setPostmanUrl(row?.url || "");
    setPostmanUserDetails(row?.user_details || "");
    setPostmanValue(row?.value || "");
    setPostmanSwaggerHub(row?.swaggerHub || false);
    setPostmanApiVersion(row?.additional_data?.apiVersion || "");
    setPostmanAuthentication(row?.additional_data?.authentication || "");
    setPostmanRateLimit(row?.additional_data?.rateLimit || "");
    setLookalikeAppId(row?._id);
  };

  const deletePostman = (_id) => {
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this postman record?",
      type: "red",
      buttons: {
        ok: {
          text: "Yes, Delete it!",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            // Call delete API here
            axios.delete(`${API_URL}/postmanRecord/${_id}?organisationId=${id}`)
              .then((response) => {
                if (response.data.error === false) {
                  toastr.success("Success", response.data.userMessage || "Postman record deleted successfully");
                  // Refresh the postman data
                  postManDelta(id, dispatch, postmanPage, "all", startDatePostman, endDatePostman, limit);
                } else {
                  toastr.error("Error", response.data.userMessage || "Failed to delete postman record");
                }
              })
              .catch((error) => {
                toastr.error("Error", "Failed to delete postman record");
                // console.error removed
              });
          },
        },
        cancel: function () {
          // User cancelled
        },
      },
    });
  };

  const clearPostman = () => {
    setPostmanRequestUrl("");
    setPostmanUrl("");
    setPostmanUserDetails("");
    setPostmanValue("");
    setPostmanSwaggerHub(false);
    setPostmanApiVersion("");
    setPostmanAuthentication("");
    setPostmanRateLimit("");
    setLookalikeAppId("");
  };

  const submitPostman = () => {
    // Enhanced validation for blank/empty fields
    if (!postmanRequestUrl || postmanRequestUrl.trim() === "") {
      toastr.error("Request URL is required and cannot be blank or empty");
      return false;
    }

    if (!postmanUrl || postmanUrl.trim() === "") {
      toastr.error("URL is required and cannot be blank or empty");
      return false;
    }

    if (!postmanUserDetails || postmanUserDetails.trim() === "") {
      toastr.error("API description/user details is required and cannot be blank or empty");
      return false;
    }

    // Validate URL format
    const urlRegex = /^https?:\/\/.+/;
    if (!urlRegex.test(postmanRequestUrl.trim())) {
      toastr.error("Please enter a valid request URL starting with http:// or https://");
      return false;
    }

    if (!urlRegex.test(postmanUrl.trim())) {
      toastr.error("Please enter a valid URL starting with http:// or https://");
      return false;
    }

    // Prepare postman data
    const additionalData = {};
    if (postmanApiVersion && postmanApiVersion.trim() !== "") {
      additionalData.apiVersion = postmanApiVersion.trim();
    }
    if (postmanAuthentication && postmanAuthentication.trim() !== "") {
      additionalData.authentication = postmanAuthentication.trim();
    }
    if (postmanRateLimit && postmanRateLimit.trim() !== "") {
      additionalData.rateLimit = postmanRateLimit.trim();
    }

    const postmanData = {
      request_url: postmanRequestUrl.trim(),
      url: postmanUrl.trim(),
      user_details: postmanUserDetails.trim(),
      value: postmanValue.trim(),
      swaggerHub: postmanSwaggerHub,
      type: "postman",
      additional_data: additionalData,
      last_updated_at: new Date().toISOString()
    };

    if (lookalikeAppId) {
      // Update existing record
      axios.put(`${API_URL}/postmanRecord/${lookalikeAppId}?organisationId=${id}`, postmanData)
        .then((response) => {
          if (response.data.error === false) {
            toastr.success("Success", response.data.userMessage || "Postman record updated successfully");
            setModal("");
            clearPostman();
            // Refresh the postman data
            postManDelta(id, dispatch, postmanPage, "all", startDatePostman, endDatePostman, limit);
          } else {
            toastr.error("Error", response.data.userMessage || "Failed to update postman record");
          }
        })
        .catch((error) => {
          toastr.error("Error", "Failed to update postman record");
          // console.error removed
        });
    } else {
      // Create new record
      axios.post(`${API_URL}/postmanRecord/${id}/entry`, postmanData)
        .then((response) => {
          if (response.data.error === false) {
            toastr.success("Success", response.data.userMessage || "Postman record added successfully");
            setModal("");
            clearPostman();
            // Refresh the postman data
            postManDelta(id, dispatch, postmanPage, "all", startDatePostman, endDatePostman, limit);
          } else {
            toastr.error("Error", response.data.userMessage || "Failed to add postman record");
          }
        })
        .catch((error) => {
          toastr.error("Error", "Failed to add postman record");
          // console.error removed
        });
    }
  };



  return (
    <>
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h2 className="welcome-text">Show Information</h2>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/" className="welcome-textSmall">Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Summary
                  </li>
                </ol>
              </nav>
            </div>
            {/* {authUser?.accessLevel != "Threat Analyst" && ( */}
            <div class="col-md-6 col-sm-12 text-right hidden-xs">
              <Link
                className="btn btn-success btn-sm mr-1"
                to={`/feed-information/${id}`}
              >
                Add Details
              </Link>
              <Link
                className="btn btn-success btn-sm mr-1"
                to={`/clients`}
              >
                Back
              </Link>
            </div>
            {/* )} */}
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="card">
              <div className="body">
                <div id="wizard_horizontal">
                  <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabChange}
                    className="card-header tab-card-header"
                  >
                    <Tab eventKey="mobile" title="Mobile Application" className="mt-0">
                      <div className="card mb-0">
                        <div className="body">
                          <div className="row">
                            <div className="col-sm-4">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={filterData}
                                onChange={(e) => {
                                  setfilterData(e.target.value);
                                  setPageMob(1);
                                }
                                }
                              >
                                <option value="">All</option>
                                <option value="android">
                                  Android
                                </option>
                                <option value="ios">IOS</option>
                                <option value="third-party">
                                  Third Party
                                </option>
                              </select>
                            </div>
                            <div className="col-sm-4">
                              <input
                                type="search"
                                placeholder="Search"
                                className="form-control form-control-sm"
                                value={mobSearch}
                                onChange={(e) => {
                                  setMobSearch(e.target.value);
                                  setPageMob(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4">
                              <input
                                type="search"
                                placeholder="Search Email"
                                className="form-control form-control-sm"
                                value={mobEmail}
                                onChange={(e) => {
                                  setMobEmail(e.target.value);
                                  setPageMob(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateMobile}
                                onChange={(e) => {
                                  setStartDateMobile(e.target.value);
                                  setPageMob(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateMobile}
                                onChange={(e) => {
                                  setEndDateMobile(e.target.value);
                                  setPageMob(1);
                                }}
                              />
                            </div>
                          </div>
                          {/* Bulk delete button for Mobile Apps */}
                          {selectedItems.mobileApp.length > 0 && (
                            <div className="d-flex justify-content-end mb-3">
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleBulkDelete('mobileApp')}
                              >
                                Delete Selected ({selectedItems.mobileApp.length})
                              </button>
                            </div>
                          )}
                          {/*  */}
                          <div className="table-responsive">
                            <table className="table table-custom spacing5 mb-0">
                              <thead>
                                <tr>
                                  <th>
                                    <input
                                      type="checkbox"
                                      checked={selectedItems.mobileApp.length === currentTableData?.length && currentTableData?.length > 0}
                                      onChange={() => handleSelectAll('mobileApp', currentTableData || [])}
                                    />
                                  </th>
                                  <th>Store Name</th>
                                  <th style={{ width: "80" }}>
                                    Application Name
                                  </th>
                                  <th style={{ width: "80" }}>
                                    Application Url
                                  </th>
                                  <th>
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {client?.subscriptionType ==
                                  "trial" ? (
                                  <tr>
                                    <td colSpan={8}>
                                      <NoData />
                                    </td>
                                  </tr>
                                ) : (
                                  currentTableData?.map(
                                    (res, index) =>
                                      !res.isBlacklist && (
                                        <tr key={index}>
                                          <td>
                                            <input
                                              type="checkbox"
                                              checked={selectedItems.mobileApp.includes(res?._id)}
                                              onChange={() => handleSelectItem('mobileApp', res?._id)}
                                            />
                                          </td>
                                          <td>
                                            {storeName(
                                              res?.source ||
                                              res?.appStoreResource
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                            }}
                                          >
                                            {res?.app_name}
                                          </td>
                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                            }}
                                          >
                                            <a
                                              href={`${res?.url}`}
                                              target="_blank"
                                              style={{
                                                color: "white",
                                              }}
                                            >
                                              Link
                                            </a>
                                          </td>
                                          <td>
                                            <a
                                              href="#"
                                              className="mr-2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                updateMobile(res)
                                              }}
                                            >
                                              Edit
                                            </a>
                                            <a
                                              href="#"
                                              className="text-danger"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                deleteModule(res?._id)
                                              }}
                                            >
                                              Delete
                                            </a>
                                          </td>
                                        </tr>
                                      )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="dataTables_paginate">
                            {totalItemsMob > 0 && (
                              <Pagination
                                className="pagination-bar"
                                currentPage={pageMob}
                                totalCount={totalItemsMob}
                                pageSize={10}
                                onPageChange={(page) =>
                                  setPageMob(page)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="source" title="Source Code" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row">
                            <div className="col-sm-4">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={filterSourceData}
                                onChange={(e) => {
                                  setfilterSourceData(e.target.value);
                                  setSourcePage(1);
                                }
                                }
                              >
                                <option value="all">All</option>
                                <option value="verified">Verified</option>
                                <option value="unverified">
                                  Unverified
                                </option>
                                <option value="takedown">takedown</option>
                                <option value="falsePositive">
                                  FalsePositive
                                </option>
                              </select>
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <input
                                type="search"
                                className="form-control form-control-sm"
                                placeholder="Search"
                                onChange={(e) => {
                                  setSourceSearch(e.target.value);
                                  setSourcePage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateSource}
                                onChange={(e) => {
                                  setStartDateSource(e.target.value);
                                  setSourcePage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateSource}
                                onChange={(e) => {
                                  setEndDateSource(e.target.value);
                                  setSourcePage(1);
                                }}
                              />
                            </div>
                          </div>
                          {/*  */}
                          <div className="table-responsive">
                            <table className="table table-custom spacing5 mb-0">
                              <thead>
                                <tr>
                                  {/*  */}
                                  <th>#</th>
                                  {auth.accessLevel !== "Client" && (
                                    <th>Status</th>
                                  )}
                                  <th>Repository Link</th>
                                  <th>Last Update at</th>
                                  <th>Created at</th>
                                  <th>Detail</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {client?.subscriptionType == "trial" ? (
                                  <tr>
                                    <td colSpan={5}>
                                      <NoData />
                                    </td>
                                  </tr>
                                ) : (
                                  currentSourceTableData?.map(
                                    (res, index) => (
                                      <tr key={index}>
                                        {/*  */}
                                        <td
                                          style={{
                                            whiteSpace: "unset",
                                          }}
                                        >
                                          <span>{(page - 1) * 10 + 1 + index}</span>
                                        </td>
                                        {auth.accessLevel !==
                                          "Client" && (
                                            <th>
                                              {" "}
                                              <span
                                                className={
                                                  res?.isSuspicious
                                                    ? "badge badge-success"
                                                    : "badge badge-danger"
                                                }
                                              >
                                                {res?.isSuspicious
                                                  ? "Verified"
                                                  : "Unverified"}
                                              </span>
                                              {res?.isLinkDown && (
                                                <span className="badge badge-warning">
                                                  Link down
                                                </span>
                                              )}
                                            </th>
                                          )}
                                        <td
                                          style={{
                                            whiteSpace: "unset",
                                          }}
                                        >
                                          <a
                                            href={`${res?.repoUrl}`}
                                            target="_blank"
                                            style={{ color: "white" }}
                                          >
                                            {res?.repoUrl}
                                          </a>
                                        </td>
                                        <td>
                                          {" "}
                                          {res?.updatedAt
                                            ? moment(
                                              res?.updatedAt
                                            ).format(
                                              "DD-MM-YYYY"
                                            )
                                            : res?.createdAt
                                              ? moment(
                                                res?.createdAt
                                              ).format(
                                                "DD-MM-YYYY"
                                              )
                                              : "NA"}
                                        </td>
                                        <td>
                                          {" "}
                                          {res?.date
                                            ? moment(res?.date).format(
                                              "DD-MM-YYYY"
                                            )
                                            : res?.createdAt
                                              ? moment(
                                                res?.createdAt
                                              ).format(
                                                "DD-MM-YYYY"
                                              )
                                              : "NA"}
                                        </td>
                                        <td
                                          onClick={() =>
                                            editModal(
                                              res?.repository[0]
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        >
                                          Detail
                                        </td>
                                        <td>
                                          <a
                                            href="#"
                                            className="mr-2"
                                            onClick={(e) => {
                                              updateSource(res)
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Edit
                                          </a>
                                          <a
                                            href="#"
                                            className="mr-2 text-danger"
                                            onClick={(e) => {
                                              deleteSource(res?._id)
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            Delete
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="dataTables_paginate">
                            {totalItemsSource > 0 && (
                              <Pagination
                                className="pagination-bar"
                                currentPage={sourcepage}
                                totalCount={totalItemsSource}
                                pageSize={10}
                                onPageChange={(sourcepage) =>
                                  setSourcePage(sourcepage)
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="social" title="Social Media Profile" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row">
                            <div className="col-lg-4 col-md-12">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={platform}
                                onChange={(e) => { setPlatform(e.target.value); setSocialPage(1) }}
                              >
                                <option value="all">All</option>
                                <option value="facebook">Facebook</option>
                                <option value="linkedin">Linkedin</option>
                                <option value="twitter">Twitter</option>
                                <option value="instagram">Instagram</option>
                              </select>
                            </div>
                            <div className="col-lg-4 col-md-12">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={status}
                                onChange={(e) => { setStatus(e.target.value); setSocialPage(1) }}
                              >
                                <option value="all">All</option>
                                <option value="verified">Verified</option>
                                <option value="unverified">Unverified</option>
                                <option value="linkdown">Takedown</option>
                              </select>
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <div className="searchBoxInput p-0">
                                <input
                                  type="search"
                                  className="form-control form-control-sm"
                                  placeholder="Search"
                                  value={socialSearch}
                                  onChange={(e) => {
                                    setSocialSearch(e.target.value);
                                    setSocialPage(1);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateSocial}
                                onChange={(e) => {
                                  setStartDateSocial(e.target.value);
                                  setSocialPage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end mt-2">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateSocial}
                                onChange={(e) => {
                                  setEndDateSocial(e.target.value);
                                  setSocialPage(1);
                                }}
                              />
                            </div>
                          </div>
                          {/* {activeBulkDelete === 'social' && (
                            <div className="d-flex justify-content-end mb-3">
                              {selectedItems.socialMedia.length > 0 && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleBulkDelete('socialMedia')}
                                >
                                  Delete Selected ({selectedItems.socialMedia.length})
                                </button>
                              )}
                            </div>
                          )} */}
                          <div className="table-responsive">
                            <table className="table table-custom spacing5 mb-0">
                              <thead>
                                <tr>
                                  {/* {activeBulkDelete === 'social' && (
                                    <th>
                                      <input
                                        type="checkbox"
                                        checked={selectedItems.socialMedia.length === currentSocialTableData?.length}
                                        onChange={() => handleSelectAll('socialMedia', currentSocialTableData || [])}
                                      />
                                    </th>
                                  )} */}
                                  <th>#No</th>
                                  <th>Status</th>
                                  <th>Platform</th>
                                  <th>Page URL</th>
                                  <th>Keyword</th>
                                  <th>Last Updated at</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {client?.subscriptionType == "trial" ? (
                                  <tr>
                                    <td colSpan={5}>
                                      <NoData />
                                    </td>
                                  </tr>
                                ) : (
                                  currentSocialTableData?.map(
                                    (res, index) => {
                                      let source =
                                        res?.source ||
                                        res?.socialMediaPlatform ||
                                        "NA";
                                      return (
                                        <tr key={index}>
                                          {/* {activeBulkDelete === 'social' && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={selectedItems.socialMedia.includes(res?._id)}
                                                onChange={() => handleSelectItem('socialMedia', res?._id)}
                                              />
                                            </td>
                                          )} */}
                                          <td>
                                            <span>{(page - 1) * 10 + 1 + index}</span>
                                          </td>
                                          <td>
                                            {" "}
                                            <span
                                              className={
                                                res?.isSuspicious
                                                  ? "badge badge-success"
                                                  : "badge badge-danger"
                                              }
                                            >
                                              {res?.isSuspicious
                                                ? "Verified"
                                                : "Unverified"}
                                            </span>
                                            {res?.isLinkDown && (
                                              <span className="badge badge-warning">
                                                Take down
                                              </span>
                                            )}
                                          </td>
                                          <td>
                                            {source
                                              .charAt(0)
                                              .toUpperCase() +
                                              source.slice(1)}
                                          </td>
                                          {/* <td>{res.name}</td> */}
                                          {/* <td>{res.subTitle}</td> */}

                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                            }}
                                          >
                                            <a
                                              href={`${res?.link ||
                                                res?.fakePageUrl
                                                }`}
                                              target="_blank"
                                              style={{ color: "white" }}
                                            >
                                              {res?.link ||
                                                res?.fakePageUrl}
                                            </a>
                                          </td>
                                          {/* <td>{res.followers}</td> */}

                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                            }}
                                          >
                                            <span className="badge badge-warning">
                                              {res.keyword || "NA"}
                                            </span>
                                          </td>
                                          <td>
                                            {res?.updatedAt
                                              ? moment(
                                                res?.updatedAt
                                              ).format(
                                                "DD-MM-YYYY"
                                              )
                                              : res?.createdAt
                                                ? moment(
                                                  res?.createdAt
                                                ).format(
                                                  "DD-MM-YYYY"
                                                )
                                                : "NA"}
                                          </td>
                                          <td>
                                            <Link to="#" className="mr-2" onClick={() => updateSocial(res)}>
                                              Edit
                                            </Link>
                                            <Link to="#" className="text-danger" onClick={() => deleteSocial(res?._id)}>
                                              Delete
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                )}
                              </tbody>
                            </table>
                            <div className="dataTables_paginate">
                              {socialTotal > 0 && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={socialPage}
                                  totalCount={socialTotal}
                                  pageSize={10}
                                  onPageChange={(page) =>
                                    setSocialPage(page)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="darkweb" title="Dark Web" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row">
                            <div className="col-md-6 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateDarkWeb}
                                onChange={(e) => {
                                  setStartDateDarkWeb(e.target.value);
                                  setDarkWebPage(1);
                                }}
                              />
                            </div>
                            <div className="col-md-6 d-flex align-items-end mt-2">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateDarkWeb}
                                onChange={(e) => {
                                  setEndDateDarkWeb(e.target.value);
                                  setDarkWebPage(1);
                                }}
                              />
                            </div>
                          </div>
                          {/* {activeBulkDelete === 'darkweb' && (
                            <div className="d-flex justify-content-end mb-3">
                              {selectedItems.darkweb.length > 0 && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleBulkDelete('darkweb')}
                                >
                                  Delete Selected ({selectedItems.darkweb.length})
                                </button>
                              )}
                            </div>
                          )} */}
                          <div className="row clearfix">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      <th>Title</th>
                                      <th>Source</th>
                                      <th>Author</th>
                                      <th>Date</th>
                                      <th>Status</th>
                                      <th>Screenshot</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {darkwebList?.data?.map((res, index) => {
                                      return (
                                        <tr key={index + "darkweb"}>
                                          <td>
                                            <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                                              {res?.title || "N/A"}
                                            </span>
                                          </td>
                                          <td>
                                            {res?.source || "N/A"}
                                          </td>
                                          <td>
                                            <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                                              {res?.author_name || res?.author || "N/A"}
                                            </span>
                                          </td>
                                          <td>
                                            {res?.date
                                              ? moment(res?.date).format("DD-MM-YYYY")
                                              : "N/A"}
                                          </td>
                                          <td>
                                            {res?.isRemidiated ? (
                                              <span className="badge badge-success">Remediated</span>
                                            ) : res?.isFalsePositive ? (
                                              <span className="badge badge-info">False Positive</span>
                                            ) : (
                                              <span className="badge badge-danger">Active</span>
                                            )}
                                          </td>
                                          <td>
                                            {res?.fixed_screenshot_path || res?.fullpage_screenshot_url ? (
                                              <Fancybox>
                                                <a
                                                  data-fancybox="gallery"
                                                  href={res?.fixed_screenshot_path || res?.fullpage_screenshot_url}
                                                >
                                                  <img
                                                    src={res?.fixed_screenshot_path || res?.fullpage_screenshot_url}
                                                    alt="Screenshot"
                                                    style={{ height: "50px", width: "auto" }}
                                                  />
                                                </a>
                                              </Fancybox>
                                            ) : (
                                              "N/A"
                                            )}
                                          </td>
                                          <td className="d-flex">
                                            <Link to="#" className="mr-2" onClick={() => updateDarkWeb(res)}>
                                              Edit
                                            </Link>
                                            <Link to="#" className="text-danger" onClick={() => fetchDarkWebDelete(id, res?._id, dispatch, darkWebPage)}>
                                              Delete
                                            </Link>
                                            {res?.thread_link && (
                                              <a href={res?.thread_link} target="_blank" className="ml-2">
                                                View Source
                                              </a>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>

                                <div className="dataTables_paginate">
                                  {darkwebList?.totalCount > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={darkWebPage}
                                      totalCount={darkwebList?.totalCount}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setDarkWebPage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="telegram" title="Telegram" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-4">
                              <input
                                className="form-control form-control-sm ml-0 my-1"
                                type="text"
                                placeholder="Search"
                                onChange={(e) => {
                                  setTelegramPage(1);
                                }}
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      <th>Message</th>
                                      <th>Telegram Group</th>
                                      <th>Message Link</th>
                                      <th>Chat Detail</th>
                                      <th>Date</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {telegramtable?.map((row, index) => (
                                      <tr key={index}>
                                        <td>{row.message}</td>
                                        <td>{row.telegramGroup}</td>
                                        <td>{row.messageLink}</td>
                                        <td>{row.chatDetail}</td>
                                        <td>{moment(row.createdAt).format('DD-MM-YYYY')}</td>
                                        <td>
                                          <div className="d-flex">
                                            <Link to="#" className="mr-2" onClick={() => updateTelegram(row)}>Edit</Link>
                                            <Link to="#" className="text-danger" onClick={() => deleteTelegram(row._id)}>Delete</Link>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              <div className="dataTables_paginate">
                                {telegramTotal > 0 && (
                                  <Pagination
                                    className="pagination-bar"
                                    currentPage={telegramPage}
                                    totalCount={telegramTotal}
                                    pageSize={10}
                                    onPageChange={(page) => setTelegramPage(page)}
                                  />
                                )}
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="pastebin" title="Pastbin Search" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-4 d-flex align-items-end">
                              <input
                                type="search"
                                className="form-control form-control-sm"
                                placeholder="Search"
                                value={pasteBinSearch}
                                onChange={(e) => {
                                  setPasteBinSearch(e.target.value);
                                  setPastePage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDatePasteBin}
                                onChange={(e) => {
                                  setStartDatePasteBin(e.target.value);
                                  setPastePage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDatePasteBin}
                                onChange={(e) => {
                                  setEndDatePasteBin(e.target.value);
                                  setPastePage(1);
                                }}
                              />
                            </div>
                            {/* {activeBulkDelete === 'pastebin' && (
                              <div className="d-flex justify-content-end mb-3">
                                {selectedItems.pastebin.length > 0 && (
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleBulkDelete('pastebin')}
                                  >
                                    Delete Selected ({selectedItems.pastebin.length})
                                  </button>
                                )}
                              </div>
                            )} */}
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      {/* {activeBulkDelete === 'pastebin' && (
                                        <th>
                                          <input
                                            type="checkbox"
                                            checked={selectedItems.pastebin.length === pastebin?.data?.length}
                                            onChange={() => handleSelectAll('pastebin', pastebin?.data || [])}
                                          />
                                        </th>
                                      )} */}
                                      <th>#No</th>
                                      <th>Title</th>
                                      <th>Link</th>
                                      <th>Snippet</th>
                                      <th>Last modified on</th>
                                      {(category === "all" ||
                                        category ===
                                        "risk-accepted" ||
                                        category ===
                                        "false-positive") && (
                                          <th style={{ width: "80" }}>
                                            Action
                                          </th>
                                        )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pastebin?.data?.map(
                                      (row, index) => (
                                        <tr
                                          key={index + "pastebin"}
                                        >
                                          {/* {activeBulkDelete === 'pastebin' && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={selectedItems.pastebin.includes(row?._id)}
                                                onChange={() => handleSelectItem('pastebin', row?._id)}
                                              />
                                            </td>
                                          )} */}
                                          <td>
                                            <span>{(page - 1) * 10 + 1 + index}</span>
                                          </td>
                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                              width: "350px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                whiteSpace:
                                                  "pre-wrap",
                                                overflowWrap:
                                                  "break-word",
                                              }}
                                            >
                                              {row?.title}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              width: "100px",
                                            }}
                                          >
                                            <a href={row?.link}>
                                              {row?.link}
                                            </a>
                                          </td>
                                          <td>
                                            <span
                                              style={{
                                                whiteSpace:
                                                  "pre-wrap",
                                                overflowWrap:
                                                  "break-word",
                                              }}
                                            >
                                              {row?.snippet}
                                            </span>
                                          </td>
                                          <td
                                            style={{
                                              whiteSpace: "unset",
                                            }}
                                          >
                                            <span className="badge badge-success">
                                              {moment(
                                                row?.createdAt
                                              ).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </td>
                                          <td className="d-flex">
                                            <Link to="#" className="mr-2" onClick={() => updatePasteBin(row)}>
                                              Edit
                                            </Link>
                                            <Link to="#" className="text-danger" onClick={() => deletePasteBin(row?._id)}>
                                              Delete
                                            </Link>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                                <div className="dataTables_paginate">
                                  {pasteTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={pastePage}
                                      totalCount={pasteTotal}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setPastePage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="malware" title="Malware Credentials" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-4">
                              <input
                                className="form-control form-control-sm ml-0 my-1"
                                type="text"
                                placeholder="Search"
                                onChange={(e) => {
                                    setMalwarePage(1);
                                  }}
                                  />
                                </div>
                                {selectedMalwareIds.length > 0 && (
                                  <div className="col-sm-4">
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={handleBulkDeleteMalware}
                                  >
                                    Delete Selected ({selectedMalwareIds.length})
                                  </button>
                                  </div>
                                )}
                                <div className="col-xl-12 col-lg-12 col-md-12">
                                  <div className="table-responsive">
                                  <table className="table table-custom spacing5 mb-0">
                                    <thead>
                                    <tr>
                                      <th>
                                      <input
                                        type="checkbox"
                                        checked={Array.isArray(malware?.data) && malware.data.length > 0 && malware.data.length === selectedMalwareIds.length}
                                        onChange={handleSelectAllMalware}
                                        className="checkUncheck"
                                      />
                                      </th>
                                      <th>Found on</th>
                                      <th>User</th>
                                      <th>Password</th>
                                      <th>Url</th>
                                      <th>Malware Type</th>
                                      <th>Infected IP</th>
                                      <th>Hardware ID</th>
                                      <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {malware?.data?.map((row, index) => (
                                      <tr key={index}>
                                      <td>
                                        <input
                                        type="checkbox"
                                        checked={selectedMalwareIds.includes(row._id)}
                                        onChange={() => handleSelectMalware(row._id)}
                                        className="checkUncheck"
                                        />
                                      </td>
                                      <td>{moment(row?.fnd).format('DD-MM-YYYY')}</td>
                                      <td>{row?.usr}</td>
                                      <td>{row?.pwd}</td>
                                      <td>{row?.src}</td>
                                      <td>{row?.mal}</td>
                                      <td>{row?.iip}</td>
                                      <td>{row?.hid}</td>
                                      <td>
                                        <div className="d-flex">
                                        <Link to="#" className="mr-2" onClick={() => updateMalware(row)}>Edit</Link>
                                        <Link to="#" className="text-danger" onClick={() => deleteMalware(row._id)}>Delete</Link>
                                        </div>
                                      </td>
                                      </tr>
                                    ))}
                                    </tbody>
                                  </table>
                                  <div className="dataTables_paginate">
                                    {malwareTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={malwarePage}
                                      totalCount={malwareTotal}
                                      pageSize={10}
                                      onPageChange={(page) => setMalwarePage(page)}
                                    />
                                    )}
                                  </div>
                                  </div>
                                </div>
                                </div>
                              </div>
                              </div>
                            </Tab>
                            <Tab eventKey="pii" title="Pii" className="mt-0">
                              <div className="card">
                              <div className="body">
                                <div className="row clearfix">
                                <div className="col-sm-4">
                                  <div
                                  data-test="datatable-res-input"
                                  className="mdb-datatable-filter flex-row"
                                  >
                                  <input
                                    className="form-control form-control-sm ml-0 my-1"
                                    type="text"
                                    placeholder="Search"
                                    aria-label="Search"
                                    value={searchPii}
                                    onChange={(e) => {
                                    setSearchPii(e.target.value);
                                    setPiiPage(1);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDatePii}
                                onChange={(e) => {
                                  setStartDatePii(e.target.value);
                                  setPiiPage(1);
                                }}
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      <th>Email</th>
                                      <th>Password</th>
                                      <th>Source</th>
                                      <th>Date</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {pii?.data?.map((row, index) => (
                                      <tr key={index}>
                                        <td>{row.email}</td>
                                        <td>{row.password}</td>
                                        <td>{row.source}</td>
                                        <td>{moment(row.createdAt).format('DD-MM-YYYY')}</td>
                                        <td className="d-flex">
                                          <Link to="#" className="mr-2" onClick={() => updatePii(row)}>Edit</Link>
                                          <Link to="#" className="text-danger" onClick={() => deletePii(row._id)}>Delete</Link>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="stolen" title="Stolen Credential" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-4">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={filterValue}
                                onChange={(e) => {
                                  setFilterValue(e.target.value);
                                  setStolenPage(1);
                                }}
                              >
                                <option value="all">All</option>
                                <option value="plain-password">Plain Password</option>
                                <option value="encrypted-password">Encrypted Password</option>
                              </select>
                            </div>
                            <div className="col-sm-4">
                              <div
                                data-test="datatable-input"
                                class="mdb-datatable-filter flex-row"
                              >
                                <input
                                  class="form-control form-control-sm ml-0 my-1"
                                  type="text"
                                  placeholder="Search"
                                  aria-label="Search"
                                  value={searchStolen}
                                  onChange={(e) => {
                                    setSearchStolen(e.target.value);
                                    setStolenPage(1);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateStolen}
                                onChange={(e) => {
                                  setStartDateStolen(e.target.value);
                                  setStolenPage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateStolen}
                                onChange={(e) => {
                                  setEndDateStolen(e.target.value);
                                  setStolenPage(1);
                                }}
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    {client?.subscriptionType == "trial" ? (
                                      <tr>
                                        <th>Breached Count</th>
                                        <th>Breached Database</th>
                                        <th>Email Address</th>
                                        <th>Password</th>
                                        <th>Last Breach</th>
                                      </tr>
                                    ) : (
                                      <tr>
                                        <th>Password Type</th>
                                        <th>Email Address</th>
                                        <th>Password</th>
                                        <th>Type</th>
                                        <th>Database name</th>
                                        <th>Description</th>
                                        <th style={{ width: "100px" }}>Date</th>
                                        <th style={{ width: "100px" }}>Action</th>
                                      </tr>
                                    )}
                                  </thead>
                                  <tbody>
                                    {client?.subscriptionType == "trial" ? (
                                      <tr>
                                        <td colSpan={5}>
                                          <NoData />
                                        </td>
                                      </tr>
                                    ) : (
                                      stolenCredential?.map((row, index) => {
                                        let password = row?.pwd?.split("") || ["N", "A"];
                                        let date = row?.imp
                                          ? row?.imp?.toString().substr(0, 4) +
                                          "-" +
                                          row?.imp?.toString().substr(4, 2) +
                                          "-" +
                                          row?.imp?.toString().substr(6, 2)
                                          : "NA";
                                        return (
                                          <tr key={index}>
                                            <td>
                                              <span
                                                className={
                                                  row?.dec == 0
                                                    ? `badge badge-success ml-0 mr-0`
                                                    : `badge badge-danger ml-0 mr-0`
                                                }
                                              >
                                                {row?.dec == 0
                                                  ? "Encrypted"
                                                  : "Plain Password"}
                                              </span>
                                            </td>
                                            <td
                                              style={{ whiteSpace: "unset", width: "100px" }}
                                            >
                                              {row?.eml || "NA"}
                                            </td>
                                            <td style={{ width: "100px" }}>
                                              <span
                                                style={{
                                                  whiteSpace: "pre-wrap",
                                                  overflowWrap: "break-word",
                                                  display: "flex",
                                                }}
                                              >
                                                <span id={`${row._id}_password`}>******</span>
                                                <i
                                                  class="fa fa-eye"
                                                  style={{
                                                    marginLeft: "10px",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                  }}
                                                  id={`${row._id}_password_icon`}
                                                  onClick={() =>
                                                    toggleIcon(row._id, password)
                                                  }
                                                ></i>
                                              </span>
                                            </td>
                                            <td>{row?.type || "NA"}</td>
                                            <td>{row?.src || "NA"}</td>
                                            <td style={{ whiteSpace: "unset" }}>
                                              {row?.atr || "NA"}
                                            </td>
                                            <td style={{ whiteSpace: "unset" }}>
                                              {row?.createdAt ? moment(row?.createdAt).format(
                                                "DD-MM-YYYY"
                                              )
                                                : "NA"}
                                            </td>
                                            <td className="d-flex">
                                              <Link to="#" className="mr-2" onClick={() => updateStolen(row)}>
                                                Edit
                                              </Link>
                                              <Link to="#" className="text-danger" onClick={() => deleteStolen(row?._id)}>
                                                Delete
                                              </Link>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    )}
                                  </tbody>
                                </table>
                                <div className="dataTables_paginate">
                                  {stolenTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={stolenPage}
                                      totalCount={stolenTotal}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setStolenPage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="leakedSessions" title="Leaked Sessions" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-4">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={leakedSessionFilter}
                                onChange={(e) => {
                                  setLeakedSessionFilter(e.target.value);
                                  setLeakedSessionPage(1);
                                }}
                              >
                                <option value="all">All</option>
                                <option value="live-session">Live Sessions</option>
                              </select>
                            </div>
                            <div className="col-sm-4">
                              <input
                                type="search"
                                className="form-control form-control-sm"
                                placeholder="Search"
                                value={leakedSessionSearch}
                                onChange={(e) => {
                                  setLeakedSessionSearch(e.target.value);
                                  setLeakedSessionPage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateLeakedSession}
                                onChange={(e) => {
                                  setStartDateLeakedSession(e.target.value);
                                  setLeakedSessionPage(1);
                                }}
                              />
                            </div>
                            <div className="col-sm-4 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateLeakedSession}
                                onChange={(e) => {
                                  setEndDateLeakedSession(e.target.value);
                                  setLeakedSessionPage(1);
                                }}
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Domain</th>
                                      <th>Value</th>
                                      <th>Path</th>
                                      <th>Session Expiry</th>
                                      <th>Found On</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {client?.subscriptionType == "trial" ? (
                                      <tr>
                                        <td colSpan={7}>
                                          <NoData />
                                        </td>
                                      </tr>
                                    ) : (
                                      leakedSessionData?.map((row, index) => {
                                        return (
                                          <tr key={`leakedSession${index}`}>
                                            <td>{row?.name || "NA"}</td>
                                            <td style={{ width: "100px" }}>{row?.dom || "NA"}</td>
                                            <td
                                              style={{
                                                width: "100px",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <span title={row?.val}>
                                                {(row?.val || "NA").slice(0, 50)}
                                              </span>
                                            </td>
                                            <td style={{ width: "100px" }}>
                                              {row?.path || "NA"}
                                            </td>
                                            <td style={{ whiteSpace: "unset" }}>
                                              {row?.expires
                                                ? (() => {
                                                  if (typeof row.expires === 'string' && row.expires.includes('T')) {
                                                    return moment(row.expires).format("DD-MM-YYYY");
                                                  } else {
                                                    return moment(row.expires * 1000).format("DD-MM-YYYY");
                                                  }
                                                })()
                                                : "NA"}
                                            </td>
                                            <td style={{ whiteSpace: "unset" }}>
                                              {row?.createdAt
                                                ? moment(row?.createdAt).format("DD-MM-YYYY")
                                                : "NA"}
                                            </td>
                                            <td>
                                              <Link to="#" className="mr-2" onClick={() => openEditLeakedSession(row)}>
                                                Edit
                                              </Link>
                                              <Link to="#" className="text-danger" onClick={() => deleteLeakedSession(row?._id)}>
                                                Delete
                                              </Link>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    )}
                                  </tbody>
                                </table>
                                <div className="dataTables_paginate">
                                  {leakedSessionTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={leakedSessionPage}
                                      totalCount={leakedSessionTotal}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setLeakedSessionPage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="cloud" title="Open Cloud Buckets" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-3">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                onChange={(e) => setfilterDataCloud(e.target.value)}
                              >
                                <option value="all">All</option>
                                <option value="aws">AWS</option>
                                <option value="azure">Azure</option>
                                <option value="gcp">Google</option>
                                <option value="dos">Dos</option>
                              </select>
                            </div>
                            <div className="col-sm-3 d-flex align-items-end">
                              <input
                                type="search"
                                placeholder="Search"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                  setSearchCloud(e.target.value);
                                }}
                              />
                            </div>
                            <div className="col-sm-3 d-flex align-items-end">
                              <label>From:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={startDateCloud}
                                onChange={(e) => {
                                  setStartDateCloud(e.target.value);
                                }}
                              />
                            </div>
                            <div className="col-sm-3 d-flex align-items-end">
                              <label>Till:</label>
                              <input
                                type="date"
                                className="ml-1 form-control form-control-sm"
                                value={endDateCloud}
                                onChange={(e) => {
                                  setEndDateCloud(e.target.value);
                                }}
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      <th>Type</th>
                                      <th>Bucket Name</th>
                                      <th>File Name</th>
                                      <th>File URL</th>
                                      <th>File Size (KBs)</th>
                                      <th>Last Updated on</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {cloudDataTable?.data?.map((res, index) => {
                                      let fullPath = res?.fullPath?.split("") || ["N", "A"];
                                      let url = res?.url?.split("") || ["N", "A"];
                                      let bucket = res?.bucket?.split("") || ["N", "A"];

                                      return (
                                        <tr key={index + "cloudbucket"}>
                                          <td>{res?.type}</td>
                                          <td>
                                            <a href={`${res?.bucket}`} target="_blank" style={{ color: "white" }}>
                                              <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                                                {bucket.map((record, indexs) => (
                                                  <span key={indexs}>
                                                    {record}
                                                    {(indexs + 1) % 40 === 0 && <br />}
                                                  </span>
                                                ))}
                                              </span>
                                            </a>
                                          </td>
                                          <td>
                                            <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                                              {fullPath.map((record, indexs) => (
                                                <span key={indexs}>
                                                  {record}
                                                  {(indexs + 1) % 40 === 0 && <br />}
                                                </span>
                                              ))}
                                            </span>
                                          </td>
                                          <td>
                                            <a href={`${res?.url}`} target="_blank" style={{ color: "white" }}>
                                              <span style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                                                {url.map((record, indexs) => (
                                                  <span key={indexs}>
                                                    {record}
                                                    {(indexs + 1) % 40 === 0 && <br />}
                                                  </span>
                                                ))}
                                              </span>
                                            </a>
                                          </td>
                                          <td>{res.size}</td>
                                          <td>
                                            {res?.updatedAt
                                              ? moment(res?.updatedAt).format("DD-MM-YYYY")
                                              : "NA"}
                                          </td>
                                          <td className="d-flex">
                                            <Link to="#" className="mr-2" onClick={() => updateCloudBucket(res)}>
                                              Edit
                                            </Link>
                                            <Link to="#" className="text-danger" onClick={() => deleteCloudBucket(res?._id)}>
                                              Delete
                                            </Link>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>

                                <div className="dataTables_paginate">
                                  {cloudTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={cloudPage}
                                      totalCount={cloudTotal}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setCloudPage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="brand" title="Brand Mention" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-3">
                              <input
                                type="text"
                                className="form-control"
                                onChange={(e) =>
                                  setBrandMentionSearch(e.target.value)
                                }
                                placeholder="Search"
                              />
                            </div>
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              {/* {activeBulkDelete === 'brand' && (
                                <div className="d-flex justify-content-end mb-3">
                                  {selectedItems.brandMention.length > 0 && (
                                    <button
                                      className="btn btn-danger btn-sm"
                                      onClick={() => handleBulkDelete('brandMention')}
                                    >
                                      Delete Selected ({selectedItems.brandMention.length})
                                    </button>
                                  )}
                                </div>
                              )} */}
                              <div className="table-responsive">
                                <table className="table table-custom spacing5 mb-0">
                                  <thead>
                                    <tr>
                                      {/* {activeBulkDelete === 'brand' && (
                                        <th>
                                          <input
                                            type="checkbox"
                                            checked={selectedItems.brandMention.length === brandMentionT?.length}
                                            onChange={() => handleSelectAll('brandMention', brandMentionT || [])}
                                          />
                                        </th>
                                      )} */}
                                      <th>Sub Domain Name</th>
                                      <th>Brand Mention Type</th>
                                      <th>Last Updated on</th>
                                      <th>Take Down</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {brandMentionT?.map(
                                      (row, index) => (
                                        <tr
                                          key={index + "pastebin"}
                                        >
                                          {/* {activeBulkDelete === 'brand' && (
                                            <td>
                                              <input
                                                type="checkbox"
                                                checked={selectedItems.brandMention.includes(row?._id)}
                                                onChange={() => handleSelectItem('brandMention', row?._id)}
                                              />
                                            </td>
                                          )} */}
                                          <td>
                                            {row?.subDomainName}
                                          </td>
                                          <td >
                                            N/A
                                          </td>
                                          <td
                                          >
                                            {moment(row?.updatedAt).format(
                                              "DD-MM-YYYY"
                                            )}
                                          </td>
                                          <td>
                                            {row?.requestStatus && row?.requestStatus != "" ? (
                                              row?.requestStatus
                                            ) : (
                                              <button
                                                className="btn btn-danger btn-sm mr-1"
                                                onClick={() => takeDownValue(row)}
                                              >
                                                Request
                                                <br />
                                                Takedown
                                              </button>
                                            )}
                                          </td>
                                          <td className="d-flex">
                                            <Link to="#" className="mr-2" onClick={() => updateBrandMention(row)}>
                                              Edit
                                            </Link>
                                            <Link to="#" className="text-danger" onClick={() => deleteBrandMention(row?._id)}>
                                              Delete
                                            </Link>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                                <div className="dataTables_paginate">
                                  {brandMentionTotal > 0 && (
                                    <Pagination
                                      className="pagination-bar"
                                      currentPage={brandMentionPage}
                                      totalCount={brandMentionTotal}
                                      pageSize={10}
                                      onPageChange={(page) =>
                                        setBrandMentionPage(page)
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="ipOpenPorts" title="IP Discovery & Open Ports" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-2">
                              <select
                                className="custom-select custom-select-sm form-control form-control-sm"
                                value={domainFilter}
                                onChange={(e) => { setDomainFilter(e.target.value); setPage(1) }}
                              >
                                <option value="">All</option>
                                {domain?.map((row, index) => {
                                  return (
                                    <option value={row}>{row?.toUpperCase()}</option>
                                  );
                                })}
                              </select>
                            </div>
                            <div className="col-sm-2">
                              <Autocomplete
                                multiple
                                id="tags-outlined"
                                onChange={(event, newValue) => {
                                  setApplyPortSearch(newValue);
                                }}
                                value={applyPortSearch}
                                options={lengthOfPort || []}
                                getOptionLabel={(option) => option.toString()}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Select Port"
                                    color="white"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-2">
                              <Autocomplete
                                multiple
                                id="tags-outlined"
                                onChange={(event, newValue) => {
                                  setApplyCountrySearch(newValue);
                                }}
                                value={applyCountrySearch}
                                options={lengthOfLocation || []}
                                getOptionLabel={(option) => option.toString()}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Country"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-sm-2">
                              <Autocomplete
                                multiple
                                id="tags-outlined"
                                onChange={(event, newValue) => {
                                  setApplyCloudSearch(newValue);
                                }}
                                value={applyCloudSearch}
                                options={lengthOfcloudLocations || []}
                                getOptionLabel={(option) => option.toString()}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Cloud Provider"
                                  />
                                )}
                              />
                            </div>
                            {ipCriticalityEnable && (
                              <div className="col-sm-2">
                                <Autocomplete
                                  multiple
                                  id="tags-outlined"
                                  onChange={(event, newValue) => {
                                    setApplyCriticality(newValue);
                                  }}
                                  value={applyCriticality}
                                  options={['Critical', 'High', 'Medium', 'Low']}
                                  getOptionLabel={(option) => option}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      placeholder="Criticality"
                                    />
                                  )}
                                />
                              </div>
                            )}
                            <div className="col-sm-2">
                              <div
                                data-test="datatable-input"
                                class="mdb-datatable-filter flex-row"
                              >
                                <input
                                  class="form-control form-control-sm ml-0 my-1"
                                  type="text"
                                  placeholder="Search"
                                  aria-label="Search"
                                  value={search}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(1);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive">
                            <table className="table table-custom spacing5 mb-0">
                              <thead>
                                <tr>
                                  <th>IP Address</th>
                                  <th>Location</th>
                                  <th>Cloud / ISP Provider</th>
                                  <th>Open Ports</th>
                                  {ipCriticalityEnable && (
                                    <th>Criticality</th>
                                  )}
                                  <th>Network Services</th>
                                  <th>Operating System</th>
                                  <th>Hosts</th>
                                  <th>Last Created on</th>
                                  <th>Action</th>

                                </tr>
                              </thead>
                              <tbody>
                                {table?.map((row, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <Tooltip text="Avatar Name" id="client1" />
                                            <div
                                              style={{
                                                fontWeight: 400,
                                                fontSize: 14,
                                              }}
                                            >
                                              {row?.ip || "NA"}
                                            </div>
                                          </div>
                                        </td>
                                        <td>{row?.location || "NA"}</td>
                                        <td>{row?.cloudOrISPProvider || "NA"}</td>
                                        <td>
                                          <div className="relative">
                                            <div className="d-flex flex-wrap">
                                              {(expandedRows.has(row.id) ? row?.openPorts : row?.openPorts?.slice(0, 5))?.map((port, index) => (
                                                <span key={index} className="badge d-inline-block m-1">
                                                  {port}
                                                </span>
                                              ))}
                                              {row?.openPorts?.length > 5 && (
                                                <div className="relative group">
                                                  <span
                                                    className="badge d-inline-block m-1 cursor-pointer"
                                                    onClick={() => {
                                                      setExpandedRows(prev => {
                                                        const newSet = new Set(prev);
                                                        if (newSet.has(row.id)) {
                                                          newSet.delete(row.id);
                                                        } else {
                                                          newSet.add(row.id);
                                                        }
                                                        return newSet;
                                                      });
                                                    }}
                                                  >
                                                    {expandedRows.has(row.id) ? 'Show less' : `+${row.openPorts.length - 5} more`}
                                                  </span>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </td>
                                        {ipCriticalityEnable && (
                                          <td>{row?.highestSeverity || "NA"}
                                            <p style={{ cursor: "pointer" }} onClick={() => riskOpen(row)}>(Detail)</p></td>
                                        )}
                                        <td>
                                          {row?.networkServices?.length > 0 && row?.networkServices[0] !== "" ? (
                                            row?.networkServices?.map((service) => (
                                              <span key={service} className="badge badge-warning d-inline-block m-1">
                                                {service}
                                              </span>
                                            ))
                                          ) : (
                                            "N/A"
                                          )}
                                        </td>
                                        <td>{row?.operatingSystem || "NA"}</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() => hostOpen(row)}
                                        >
                                          Host Detail
                                        </td>
                                        <td>
                                          {row?.createdAt
                                            ? moment(row?.createdAt).format(
                                              "DD-MM-YYYY"
                                            )
                                            : "NA"}
                                        </td>
                                        <td className="d-flex">
                                          <Link to="#" className="mr-2" onClick={() => updateIpdiscoveryOpenPorts(row)}>
                                            Edit
                                          </Link>
                                          <Link to="#" className="text-danger" onClick={() => deleteipAssets(row?._id)}>
                                            Delete
                                          </Link>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                          <div className="dataTables_paginate">
                            {totalItemsIpPorts > 0 && (
                              <Pagination
                                className="pagination-bar"
                                currentPage={pageIpPorts}
                                totalCount={totalItemsIpPorts}
                                pageSize={limit}
                                onPageChange={(page) => setPageIpPorts(page)}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey="postmanMonitoring" title="Postman Monitoring" className="mt-0">
                      <div className="card">
                        <div className="body">
                          <div className="row clearfix">
                            <div className="col-sm-3 mb-2">
                              <div className="searchBoxInput p-0">
                                <input
                                  className="form-control form-control-sm ml-0 my-1"
                                  type="text"
                                  placeholder="Search Postman Records"
                                  aria-label="Search"
                                  value={postmanSearch}
                                  onChange={(e) => {
                                    setPostmanSearch(e.target.value);
                                    setPostmanPage(1);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-3 mb-2">
                              <div className="date-picker-container">
                                <div className="date-range-input">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Select date range"
                                    value={formatDateRange()}
                                    onClick={() => setDatePickerOpen(true)}
                                    readOnly
                                  />
                                  <span className="calendar-icon">
                                    <i className="fa fa-calendar" aria-hidden="true"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="table table-custom spacing5 mb-0">
                              <thead>
                                <tr>
                                  <th>Request URL</th>
                                  <th>Workspace URL</th>
                                  <th>User Details</th>
                                  <th>Swagger Hub</th>
                                  <th>Last Updated</th>
                                  {/* <th>Actions</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {postmanData && postmanData.length > 0 ? (
                                  postmanData
                                    .filter((row) => {
                                      if (postmanSearch === "") return true;
                                      return (
                                        row?.request_url?.toLowerCase().includes(postmanSearch.toLowerCase()) ||
                                        row?.url?.toLowerCase().includes(postmanSearch.toLowerCase()) ||
                                        row?.user_details?.toLowerCase().includes(postmanSearch.toLowerCase())
                                      );
                                    })
                                    .map((row, index) => (
                                      <tr key={index}>
                                        <td>
                                          <a href={row?.request_url} target="_blank" rel="noopener noreferrer">
                                            {row?.request_url ? (
                                              row.request_url.length > 50 ?
                                                `${row.request_url.substring(0, 50)}...` :
                                                row.request_url
                                            ) : "N/A"}
                                          </a>
                                        </td>
                                        <td>
                                          <a href={row?.url} target="_blank" rel="noopener noreferrer">
                                            {row?.url ? (
                                              row.url.length > 50 ?
                                                `${row.url.substring(0, 50)}...` :
                                                row.url
                                            ) : "N/A"}
                                          </a>
                                        </td>
                                        <td>
                                          {row?.user_details ? (
                                            row.user_details.length > 100 ?
                                              `${row.user_details.substring(0, 100)}...` :
                                              row.user_details
                                          ) : "N/A"}
                                        </td>
                                        <td>
                                          <span className={`badge ${row?.swaggerHub ? 'badge-success' : 'badge-secondary'}`}>
                                            {row?.swaggerHub ? "Yes" : "No"}
                                          </span>
                                        </td>
                                        <td>
                                          {row?.last_updated_at ?
                                            moment(row.last_updated_at).format("DD-MM-YYYY HH:mm") :
                                            "N/A"
                                          }
                                        </td>
                                        {/* <td>
                                          {authUser?.accessLevel !== "Threat Analyst" && (
                                            <>
                                              <Link
                                                to="#"
                                                className="mr-2"
                                                onClick={() => {
                                                  updatePostman(row);
                                                  setModal("postmanModal");
                                                }}
                                                title="Edit Record"
                                              >
                                                <i className="fa fa-edit text-primary"></i>
                                              </Link>
                                              <Link
                                                to="#"
                                                onClick={() => deletePostman(row._id)}
                                                title="Delete Record"
                                              >
                                                <i className="fa fa-trash text-danger"></i>
                                              </Link>
                                            </>
                                          )}
                                        </td> */}
                                      </tr>
                                    ))
                                ) : (
                                  <tr>
                                    <td colSpan="6" className="text-center">
                                      <i>No Postman records found. Click "Add Postman Record" to get started.</i>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Pagination */}
                          <div className="d-flex justify-content-between align-content-center mt-3">
                            <div className="dataTables_paginate">
                              {postmanTotal > 0 && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={postmanPage}
                                  totalCount={postmanTotal}
                                  pageSize={limit}
                                  onPageChange={(page) => setPostmanPage(page)}
                                />
                              )}
                            </div>
                            {postmanTotal > 10 && (
                              <select
                                value={limit}
                                onChange={(e) => setLimit(e.target.value)}
                                className="form-control limitSelectBox"
                              >
                                <option value={10}>10 per page</option>
                                <option value={25}>25 per page</option>
                                <option value={50}>50 per page</option>
                                <option value={100}>100 per page</option>
                              </select>
                            )}
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {

                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            className="form-control"
                            value={actionNote}
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${mobileModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Mobile Application
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setMobileModal("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={appName}
                              onChange={(e) =>
                                setAppName(e.target.value)
                              }
                              placeholder="Application Name *"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              placeholder="Application URL *"
                              className="form-control"
                              value={appStoreUrl}
                              onChange={(e) =>
                                setAppStoreUrl(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={appStoreResource}
                              onChange={(e) =>
                                setAppStoreResource(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Source *--
                              </option>
                              <option value="Google Play Store">
                                Google Play Store
                              </option>
                              <option value="Apple Store">Apple Store</option>
                              <option value="Third Party Store">
                                Third Party Store
                              </option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={appStoreSeverity}
                              onChange={(e) =>
                                setAppStoreSeverity(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Severity *--
                              </option>
                              <option value="critical">Critical</option>
                              <option value="high">High</option>
                              <option value="medium">Medium</option>
                              <option value="low">Low</option>
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-12">
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                Upload Logo
                              </span>
                            </div>
                            <div className="custom-file">
                              <input
                                onChange={handleLogoChange('mobileApp')}
                                type="file"
                                className="custom-file-input"
                                id="inputGroupFile01"
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="inputGroupFile01"
                              >
                                {upload ? `Upload: ${upload}` : "Choose file"}
                              </label>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          submitMobileApplication();
                        }}
                      >
                        Submit
                      </button>{" "}
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${ipOpenModal === "Form Wizard modal ip" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update IP Discovery & Open Ports
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setIpOpenModal("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Cloud Or Isp Provider"
                              value={cloudOrISPProvider}
                              onChange={(e) => setCloudOrISPProvider(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Highest Serverity"
                              value={highestSeverity}
                              onChange={(e) => setHighestSeverity(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Ip"
                              value={ip}
                              onChange={(e) => setIp(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Location"
                              value={location}
                              onChange={(e) => setLocation(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="subdomains"
                              value={subdomains}
                              onChange={(e) => setSubdomains(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Operating System"
                              value={operatingSystem}
                              onChange={(e) => setOperatingSystem(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="createdAt">Updated At</label>
                            <input
                              type="date"
                              className="form-control"
                              value={updatedAtIp}
                              onChange={(e) => setUpdatedAtIp(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="createdAt">Created At</label>
                            <input
                              type="date"
                              className="form-control"
                              value={createdAtIp}
                              onChange={(e) => setCreatedAtIp(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group d-flex">
                            <input
                              type="text"
                              placeholder="Hosts"
                              className="form-control"
                              id="hosts"
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", fontWeight: "800" }}
                              onClick={() => addValue("hosts")}
                            >
                              Add
                            </button>
                          </div>
                          {hosts.length > 0 && (
                            <ul className="p-0 pl-1">
                              {hosts.map((host, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                  {host}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeValue("hosts", index)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        {/* Impacts Input */}
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group d-flex">
                            <input
                              type="text"
                              placeholder="Impacts"
                              className="form-control"
                              id="impacts"
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", fontWeight: "800" }}
                              onClick={() => addValue("impacts")}
                            >
                              Add
                            </button>
                          </div>
                          {impacts.length > 0 && (
                            <ul className="p-0 pl-1">
                              {impacts.map((impact, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                  {impact}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeValue("impacts", index)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        {/* Network Services Input */}
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group d-flex">
                            <input
                              type="text"
                              placeholder="Network Services"
                              className="form-control"
                              id="networkServices"
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", fontWeight: "800" }}
                              onClick={() => addValue("networkServices")}
                            >
                              Add
                            </button>
                          </div>
                          {networkServices.length > 0 && (
                            <ul className="p-0 pl-1">
                              {networkServices.map((service, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                  {service}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeValue("networkServices", index)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        {/* Open Ports Input */}
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group d-flex">
                            <input
                              type="text"
                              placeholder="Open Ports"
                              className="form-control"
                              id="openPorts"
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", fontWeight: "800" }}
                              onClick={() => addValue("openPorts")}
                            >
                              Add
                            </button>
                          </div>
                          {openPorts.length > 0 && (
                            <ul className="p-0 pl-1">
                              {openPorts.map((port, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                  {port}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeValue("openPorts", index)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>

                        {/* Recommendations Input */}
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group d-flex">
                            <input
                              type="text"
                              placeholder="Recommendations"
                              className="form-control"
                              id="recommendations"
                            />
                            <button
                              type="button"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", fontWeight: "800" }}
                              onClick={() => addValue("recommendations")}
                            >
                              Add
                            </button>
                          </div>
                          {recommendations.length > 0 && (
                            <ul className="p-0 pl-1">
                              {recommendations.map((rec, index) => (
                                <li key={index} className="d-flex justify-content-between">
                                  {rec}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => removeValue("recommendations", index)}
                                  >
                                    Remove
                                  </button>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          submitIpOpernPorts();
                        }}
                      >
                        Submit
                      </button>{" "}
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${sourceModal === "Form Wizard modal source" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Source Code
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalSource("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Repository URL"
                              value={repoUrl}
                              onChange={(e) =>
                                setRepoUrl(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={programmingLanguage}
                              onChange={(e) =>
                                setProgrammingLanguage(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Programming Language --
                              </option>
                              <option value="java">Java</option>
                              <option value="php">PHP</option>
                              <option value="python">Python</option>
                              <option value="c++">C++</option>
                              <option value="c#">C#</option>
                              <option value="r">R</option>
                              <option value="js">Java Script</option>
                              <option value="golang">Go Lang</option>
                              <option value="ts">Type Script</option>
                              <option value="ruby">Ruby</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={severityLevel}
                              onChange={(e) =>
                                setSourceCodeSeverity(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Severity --
                              </option>
                              <option value="critical">Critical</option>
                              <option value="high">High</option>
                              <option value="medium">Medium</option>
                              <option value="low">Low</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <textarea
                              rows="4"
                              type="text"
                              className="form-control"
                              placeholder="Leaked Code"
                              value={leakedCode}
                              onChange={(e) =>
                                setLeakedCode(e.target.value)
                              }
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          submitSourceCode();
                        }}
                      >
                        Submit
                      </button>{" "}
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${socialModal === "Form Wizard modal social" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Social Media
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalSocial("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Page/Profile URL"
                              value={fakePageUrl}
                              onChange={(e) =>
                                setFakePageUrl(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={socialMediaPlatform}
                              onChange={(e) =>
                                setSocialMediaPlatform(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Source --
                              </option>
                              <option value="linkedin">LinkedIn</option>
                              <option value="facebook">Facebook</option>
                              <option value="instagram">
                                Instagram
                              </option>
                              <option value="twitter">Twitter</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={socialSeverity}
                              onChange={(e) =>
                                setSocialSeverity(e.target.value)
                              }
                            >
                              <option value="">
                                -- Select Severity --
                              </option>
                              <option value="critical">Critical</option>
                              <option value="high">High</option>
                              <option value="medium">Medium</option>
                              <option value="low">Low</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <textarea
                              rows="4"
                              type="text"
                              className="form-control"
                              placeholder="Comments"
                              value={socialComments}
                              onChange={(e) =>
                                setSocialComments(e.target.value)
                              }
                            ></textarea>
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="header">
                              <h2>Upload Evidence</h2>
                            </div>
                            <div className="body">
                              <Dropzone
                                variable={setSocialAttachment}
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          submitSocialMedia();
                        }}
                      >
                        Submit
                      </button>{" "}
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${pastbinModal === "Form Wizard modal pastebin" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Pastbin Search
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setPastbinModal("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="title"
                              value={title}
                              onChange={(e) =>
                                setTitle(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="snippet"
                              value={snippet}
                              onChange={(e) =>
                                setSnippet(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="date"
                              value={date}
                              onChange={(e) =>
                                setDate(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="link"
                              value={link}
                              onChange={(e) =>
                                setLink(e.target.value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          submitPastbinSearch();
                        }}
                      >
                        Submit
                      </button>{" "}
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${darkWebModal === "Form Wizard modal dark web" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Dark Web Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalDarkWeb("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Title"
                              value={titleDarkWeb}
                              onChange={(e) => setTitleDarkWeb(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Thread Link"
                              value={threadLinkDarkWeb}
                              onChange={(e) => setThreadLinkDarkWeb(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Author Name"
                              value={authorNameDarkWeb}
                              onChange={(e) => setAuthorNameDarkWeb(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Source"
                              value={sourceSourceDarkWeb}
                              onChange={(e) => setSourceDarkWeb(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Author Link"
                              value={authorLinkDarkWeb}
                              onChange={(e) => {
                                setAuthorLinkDarkWeb(e.target.value)
                                setAuthorDarkWeb(e.target.value)
                              }}
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Author"
                              value={authorDarkWeb}
                              onChange={(e) => setAuthorDarkWeb(e.target.value)}
                            />
                          </div>
                        </div> */}
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              value={dateDarkWeb}
                              onChange={(e) => setDateDarkWeb(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="header">
                              <h2>Upload Evidence</h2>
                            </div>
                            <div className="body">
                              <Dropzone
                                variable={setDarkWebAttachmentUrl}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={submitDarkWebData}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div
          className={`modal fade Form-Wizard-modal ${modalTelegram === "Form Wizard modal Telegram" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Telegram Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalTelegram("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Group Name"
                              value={groupname}
                              onChange={(e) =>
                                setGroupName(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Message Link"
                              value={messagelink}
                              onChange={(e) =>
                                setMessageLink(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="date"
                              value={telegramDate}
                              onChange={(e) =>
                                setTelegramDate(e.target.value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <div className="form-group">
                            <textarea
                              rows="4"
                              type="text"
                              className="form-control"
                              placeholder="Message"
                              value={message}
                              onChange={(e) =>
                                setMessage(e.target.value)
                              }
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="card">
                            <div className="header">
                              <h2>Upload Evidence</h2>
                            </div>
                            <div className="body">
                              <Dropzone
                                data="upload_telegram"
                                variable={setTelegramImg}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={(e) => {
                          submitTelegram();
                        }}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div
          className={`modal fade Form-Wizard-modal ${modalMalware === "Form Wizard modal Malware" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Malware Credentials Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalMalware("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">

                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="User"
                              value={usr}
                              onChange={(e) => setUsr(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Source"
                              value={src}
                              onChange={(e) => setSrc(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Mal"
                              value={mal}
                              onChange={(e) => setMal(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control"
                              placeholder="Password"
                              value={pwd}
                              onChange={(e) => setPwd(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="IP Address"
                              value={iip}
                              onChange={(e) => setIip(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="HID"
                              value={hid}
                              onChange={(e) => setHid(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Created At"
                              value={createdAt}
                              onChange={(e) => setCreatedAt(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Found Date"
                              value={fnd}
                              onChange={(e) => setFnd(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={submitMalware}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div
          className={`modal fade Form-Wizard-modal ${modalStolen === "Form Wizard modal Stolen" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Stolen Credentials Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalStolen("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Email"
                              value={eml}
                              onChange={(e) => setEml(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Source"
                              value={srcMalware}
                              onChange={(e) => setSrcMalware(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Created At"
                              value={createdAtMalware}
                              onChange={(e) => setCreatedAtMalware(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control"
                              placeholder="Password"
                              value={pwdMalware}
                              onChange={(e) => setMalware(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <select
                              className="form-control"
                              value={stolenCredentialType}
                              onChange={(e) => setStolenCredentialType(e.target.value)}
                            >
                              <option value="">-- Select Type --</option>
                              <option value="combo">Combo</option>
                              <option value="thirdParty">Third Party</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={submitStolen}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${piiModal === "Form Wizard modal pii" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Pii Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setPiiModal("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="IP Address"
                              value={ip_address}
                              onChange={(e) => setIp_address(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Database Name"
                              value={database_name}
                              onChange={(e) => setDatabase_name(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Created At"
                              value={createdAtDate}
                              onChange={(e) => setCreatedAtDate(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={submitPii}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div
          className={`modal fade Form-Wizard-modal ${cloudBucketModalModal === "Form Wizard modal cloud" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Update Cloud Bucket Data
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setCloudBucketModal("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Bucket"
                              value={bucket}
                              onChange={(e) => setBucket(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Full Path"
                              value={fullPath}
                              onChange={(e) => setFullPath(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Size"
                              value={size}
                              onChange={(e) => setSize(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Type"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Filename"
                              value={filename}
                              onChange={(e) => setFilename(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="URL"
                              value={url}
                              onChange={(e) => setUrl(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <input
                              type="date"
                              className="form-control"
                              placeholder="Updated At"
                              value={updateAt}
                              onChange={(e) => setUpdatedAtCloud(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-round btn-primary mr-1"
                        onClick={submitCloud}
                      >
                        Submit
                      </button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${isModalhost === "Form Wizard modal host" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Hosts
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalHost("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <div className="col-lg-12 col-md-12">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Host</th>
                                <th>Last Updated on</th>
                              </tr>
                            </thead>
                            <tbody>
                              {hosts?.hosts?.map((host) => (
                                <tr key={host}>
                                  <td>{host}</td>
                                  <td>
                                    {moment(hosts?.updatedAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalhost === "Port Wizard modal host" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Risk Details
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalHost("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Impact</th>
                            <th>Recommendations</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hosts?.impacts?.map((impact, index) => (
                            <tr key={index}>
                              <td style={{ whiteSpace: 'pre-wrap' }}>{impact}</td>
                              <td style={{ whiteSpace: 'pre-wrap' }}>{hosts?.recommendations?.[index]}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Leaked Session Edit Modal */}
      <div className={`modal fade Form-Wizard-modal ${isModal === "editLeakedSession" ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editedData?._id ? "Edit Leaked Session" : "Add Leaked Session"}</h5>
              <button
                type="button"
                className="close"
                onClick={() => {
                  clearLeakedSession();
                  setModal("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Session Name *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editedData?.name || ""}
                          onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
                          placeholder="Session name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Domain *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editedData?.dom || ""}
                          onChange={(e) => setEditedData({ ...editedData, dom: e.target.value })}
                          placeholder="example.com"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Session Value *</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editedData?.val || ""}
                          onChange={(e) => setEditedData({ ...editedData, val: e.target.value })}
                          placeholder="Session value"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Path</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editedData?.path || "/"}
                          onChange={(e) => setEditedData({ ...editedData, path: e.target.value })}
                          placeholder="/"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Found Location</label>
                        <input
                          type="text"
                          className="form-control"
                          value={editedData?.fnd || ""}
                          onChange={(e) => setEditedData({ ...editedData, fnd: e.target.value })}
                          placeholder="Where it was found"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Expiry Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={editedData?.expires ? (typeof editedData.expires === 'string' && editedData.expires.includes('T') ? editedData.expires.split('T')[0] : moment(editedData.expires * 1000).format('YYYY-MM-DD')) : ""}
                          onChange={(e) => setEditedData({ ...editedData, expires: e.target.value })}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-right">
                    <button
                      className="mr-2 btn btn-round btn-default"
                      onClick={() => {
                        clearLeakedSession();
                        setModal("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={submitLeakedSession}
                    >
                      {editedData?._id ? "Update Leaked Session" : "Add Leaked Session"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Brand Mention Edit Modal */}
      <div className={`modal fade Form-Wizard-modal ${brandMentionModal ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Brand Mention</h5>
              <button
                type="button"
                className="close"
                onClick={brandMentionClear}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Sub Domain Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={host}
                          onChange={(e) => setHost(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Last Updated On</label>
                        <input
                          type="date"
                          className="form-control"
                          value={updatedAt}
                          onChange={(e) => setUpdatedAt(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-right">
                    <button
                      className="mr-2 btn btn-round btn-default"
                      onClick={brandMentionClear}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={submitBrandMention}
                    >
                      Update Brand Mention
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Postman Monitoring Modal */}
      <div className={`modal fade Form-Wizard-modal ${isModal === "postmanModal" ? "d-block show" : ""}`}>
        <div className="modal-dialog modal-xl" id="postmanModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="postmanModalLabel">
                {lookalikeAppId ? "Edit Postman Record" : "Add Postman Record"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  clearPostman();
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="body">
                    <div className="row clearfix">
                      {/* Essential Information */}
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <label className="form-label">Request URL *</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://api.example.com/v1/users"
                            value={postmanRequestUrl}
                            onChange={(e) => setPostmanRequestUrl(e.target.value)}
                          />
                          <small className="form-text text-muted">The full API endpoint URL discovered in Postman</small>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <label className="form-label">Workspace URL *</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="https://postman.com/workspace/example-workspace"
                            value={postmanUrl}
                            onChange={(e) => setPostmanUrl(e.target.value)}
                          />
                          <small className="form-text text-muted">The Postman workspace or collection URL</small>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <label className="form-label">API Description/User Details *</label>
                          <textarea
                            rows="3"
                            className="form-control"
                            placeholder="Describe the API endpoint functionality, exposed user information, or security concerns"
                            value={postmanUserDetails}
                            onChange={(e) => setPostmanUserDetails(e.target.value)}
                          />
                          <small className="form-text text-muted">Detailed description of what this API does and any sensitive data it exposes</small>
                        </div>
                      </div>

                      {/* Additional Metadata */}
                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <label className="form-label">API Version</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="v1, v2, etc."
                            value={postmanApiVersion}
                            onChange={(e) => setPostmanApiVersion(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <label className="form-label">Authentication Type</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Bearer token, API key, Basic auth"
                            value={postmanAuthentication}
                            onChange={(e) => setPostmanAuthentication(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-12">
                        <div className="form-group">
                          <label className="form-label">Rate Limiting</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="1000 requests/hour, No limit"
                            value={postmanRateLimit}
                            onChange={(e) => setPostmanRateLimit(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Technical Details */}
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <label className="form-label">Technical Details & Findings</label>
                          <textarea
                            rows="4"
                            className="form-control"
                            placeholder="Include any credentials found, exposed parameters, security vulnerabilities, or additional technical information"
                            value={postmanValue}
                            onChange={(e) => setPostmanValue(e.target.value)}
                          />
                          <small className="form-text text-muted">Document any sensitive information, credentials, or security issues discovered</small>
                        </div>
                      </div>

                      {/* Flags and Indicators */}
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              id="postmanSwaggerHubModal"
                              checked={postmanSwaggerHub}
                              onChange={(e) => setPostmanSwaggerHub(e.target.checked)}
                              className="mr-2"
                            />
                            <label htmlFor="postmanSwaggerHubModal" className="mb-0">
                              Available on SwaggerHub
                            </label>
                          </div>
                          <small className="form-text text-muted">Check if this API is also documented on SwaggerHub</small>
                        </div>
                      </div>

                      {/* Help Section */}
                      <div className="col-lg-12 col-md-12">
                        <div className="alert alert-info d-flex align-items-center mt-3" role="alert">
                          <i className="fa fa-info-circle mr-3 fa-lg"></i>
                          <div className="small">
                            <strong>Tip:</strong> This form is for documenting exposed Postman workspaces that may contain
                            sensitive API information, credentials, or endpoints that should be secured.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12 col-md-12" style={{ marginRight: "28px" }}>
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submitPostman}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          <i className="fa fa-save mr-2"></i>
                          {lookalikeAppId ? "Update Record" : "Add Record"}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            clearPostman();
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          <i className="fa fa-times mr-2"></i>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowInformation;
